export default {
  svg: {
    // PARKET
    'p-l-1-1': {x: 140.200724, y:10.5408432},
    'p-l-1-2': {x: 149.776834, y:14.3772973},
    'p-l-1-3': {x: 159.487234, y:17.8607135},
    'p-l-1-4': {x: 169.315051, y:20.9976649},
    'p-l-1-5': {x: 179.242461, y:23.8042378},
    'p-l-1-6': {x: 189.255359, y:26.2890811},
    'p-l-1-7': {x: 199.341113, y:28.4600649},
    'p-l-1-8': {x: 209.488041, y:30.3242811},
    'p-l-1-9': {x: 219.685761, y:31.8882162},
    'p-l-1-10': {x: 229.924235, y:33.1576649},
    'p-l-1-11': {x: 240.194551, y:34.1377297},
    'p-l-1-12': {x: 250.488056, y:34.8332541},
    'p-l-1-13': {x: 260.796703, y:35.2483892},
    'p-l-1-14': {x: 271.112792, y:35.387027},
    'p-r-1-15': {x: 281.428967, y:35.2464865},
    'p-r-1-16': {x: 291.737528, y:34.8292757},
    'p-r-1-17': {x: 302.03086, y:34.1319351},
    'p-r-1-18': {x: 312.301003, y:33.1499676},
    'p-r-1-19': {x: 322.539304, y:31.8786162},
    'p-r-1-20': {x: 332.736677, y:30.3127784},
    'p-r-1-21': {x: 342.88326, y:28.4464865},
    'p-r-1-22': {x: 352.968494, y:26.2732541},
    'p-r-1-23': {x: 362.980787, y:23.7859027},
    'p-r-1-24': {x: 372.907331, y:20.9765622},
    'p-r-1-25': {x: 382.734196, y:17.8363243},
    'p-r-1-26': {x: 392.444423, y:14.3523027},
    'p-r-1-27': {x: 402.018803, y:10.5116973},


    'p-l-2-1': {x: 135.211321, y:24.0572973},
    'p-l-2-2': {x: 144.760088, y:27.9613838},
    'p-l-2-3': {x: 154.44678, y:31.5100108},
    'p-l-2-4': {x: 164.252187, y:34.7162378},
    'p-l-2-5': {x: 174.159954, y:37.5915676},
    'p-l-2-6': {x: 184.154422, y:40.1493189},
    'p-l-2-7': {x: 194.223044, y:42.3984},
    'p-l-2-8': {x: 204.354225, y:44.3465946},
    'p-l-2-9': {x: 214.537581, y:46.0009081},
    'p-l-2-10': {x: 224.763595, y:47.3677405},
    'p-l-2-11': {x: 235.023354, y:48.452627},
    'p-l-2-12': {x: 245.30864, y:49.2605838},
    'p-l-2-13': {x: 255.611836, y:49.7961946},
    'p-l-2-14': {x: 265.925415, y:50.0633514},
    'p-r-2-15': {x: 276.242455, y:50.0631784},
    'p-r-2-16': {x: 286.556035, y:49.7955027},
    'p-r-2-17': {x: 296.859144, y:49.2596324},
    'p-r-2-18': {x: 307.144429, y:48.4514162},
    'p-r-2-19': {x: 317.404189, y:47.3663568},
    'p-r-2-20': {x: 327.630116, y:45.9993514},
    'p-r-2-21': {x: 337.813473, y:44.3446919},
    'p-r-2-22': {x: 347.944567, y:42.3960649},
    'p-r-2-23': {x: 358.013015, y:40.1463784},
    'p-r-2-24': {x: 368.007397, y:37.5876757},
    'p-r-2-25': {x: 377.914646, y:34.7111351},
    'p-r-2-26': {x: 387.720658, y:31.5064649},
    'p-r-2-27': {x: 397.406657, y:27.9558486},
    'p-r-2-28': {x: 406.955944, y:24.0531459},


    'p-l-3-1': {x: 130.099568, y:38.1141189},
    'p-l-3-2': {x: 139.63752, y:42.0446703},
    'p-l-3-3': {x: 149.316857, y:45.6132757},
    'p-l-3-4': {x: 159.113611, y:48.8460541},
    'p-l-3-5': {x: 169.012466, y:51.7517405},
    'p-l-3-6': {x: 178.997936, y:54.3446919},
    'p-l-3-7': {x: 189.056866, y:56.6367568},
    'p-l-3-8': {x: 199.177923, y:58.6365838},
    'p-l-3-9': {x: 209.351242, y:60.3520432},
    'p-l-3-10': {x: 219.567479, y:61.7901405},
    'p-l-3-11': {x: 229.81824, y:62.9567568},
    'p-l-3-12': {x: 240.09591, y:63.857427},
    'p-l-3-13': {x: 250.393049, y:64.4969081},
    'p-l-3-14': {x: 260.703081, y:64.8795243},
    'p-l-3-15': {x: 271.019343, y:65.0089081},
    'p-r-3-16': {x: 281.335691, y:64.8820324},
    'p-r-3-17': {x: 291.645723, y:64.5025297},
    'p-r-3-18': {x: 301.943208, y:63.8661622},
    'p-r-3-19': {x: 312.221052, y:62.9686919},
    'p-r-3-20': {x: 322.472245, y:61.8052757},
    'p-r-3-21': {x: 332.689001, y:60.3704649},
    'p-r-3-22': {x: 342.862839, y:58.6581189},
    'p-r-3-23': {x: 352.984588, y:56.6612324},
    'p-r-3-24': {x: 363.044125, y:54.3719351},
    'p-r-3-25': {x: 373.030199, y:51.7815784},
    'p-r-3-26': {x: 382.930266, y:48.8799568},
    'p-r-3-27': {x: 392.728318, y:45.6512432},
    'p-r-3-28': {x: 402.408088, y:42.0840216},
    'p-r-3-29': {x: 411.948462, y:38.1592649},


    'p-l-4-1': {x: 134.520663, y:55.6794378},
    'p-l-4-2': {x: 144.17681, y:59.3100541},
    'p-l-4-3': {x: 153.955653, y:62.5965405},
    'p-l-4-4': {x: 163.836684, y:65.5623351},
    'p-l-4-5': {x: 173.806838, y:68.2136649},
    'p-l-4-6': {x: 183.851232, y:70.5685189},
    'p-l-4-7': {x: 193.958704, y:72.6364108},
    'p-l-4-8': {x: 204.119131, y:74.4259027},
    'p-l-4-9': {x: 214.323686, y:75.9444324},
    'p-l-4-10': {x: 224.564237, y:77.1986595},
    'p-l-4-11': {x: 234.833082, y:78.1944649},
    'p-l-4-12': {x: 245.123385, y:78.9367784},
    'p-l-4-13': {x: 255.428658, y:79.4301838},
    'p-l-4-14': {x: 265.742843, y:79.678573},
    'p-r-4-15': {x: 276.059884, y:79.681773},
    'p-r-4-16': {x: 286.374242, y:79.4422054},
    'p-r-4-17': {x: 296.679947, y:78.9577946},
    'p-r-4-18': {x: 306.970856, y:78.2244757},
    'p-r-4-19': {x: 317.240653, y:77.2378378},
    'p-r-4-20': {x: 327.482242, y:75.9927784},
    'p-r-4-21': {x: 337.688182, y:74.4833297},
    'p-r-4-22': {x: 347.850339, y:72.7030054},
    'p-r-4-23': {x: 357.959542, y:70.6441081},
    'p-r-4-24': {x: 368.006099, y:68.2981622},
    'p-r-4-25': {x: 377.978589, y:65.6554811},
    'p-r-4-26': {x: 387.863773, y:62.7037838},
    'p-r-4-27': {x: 397.645472, y:59.4256865},
    'p-r-4-28': {x: 407.30707, y:55.8095135},


    'p-l-5-1': {x: 139.272463, y:73.1319784},
    'p-l-5-2': {x: 149.03651, y:76.462227},
    'p-l-5-3': {x: 158.905167, y:79.4690162},
    'p-l-5-4': {x: 168.862602, y:82.1674811},
    'p-l-5-5': {x: 178.895574, y:84.5703351},
    'p-l-5-6': {x: 188.992057, y:86.6913297},
    'p-l-5-7': {x: 199.141928, y:88.5397189},
    'p-l-5-8': {x: 209.336619, y:90.1235459},
    'p-l-5-9': {x: 219.567998, y:91.4500757},
    'p-l-5-10': {x: 229.828882, y:92.5253622},
    'p-l-5-11': {x: 240.112523, y:93.355027},
    'p-l-5-12': {x: 250.412778, y:93.9437405},
    'p-l-5-13': {x: 260.723934, y:94.2955676},
    'p-l-5-14': {x: 271.040369, y:94.414227},
    'p-r-5-15': {x: 281.356804, y:94.2970378},
    'p-r-5-16': {x: 291.668047, y:93.9469405},
    'p-r-5-17': {x: 301.968387, y:93.3601297},
    'p-r-5-18': {x: 312.252201, y:92.5324541},
    'p-r-5-19': {x: 322.513259, y:91.4590703},
    'p-r-5-20': {x: 332.744811, y:90.1344432},
    'p-r-5-21': {x: 342.939848, y:88.5524324},
    'p-r-5-22': {x: 353.090151, y:86.705773},
    'p-r-5-23': {x: 363.186807, y:84.5862486},
    'p-r-5-24': {x: 373.220213, y:82.1845189},
    'p-r-5-25': {x: 383.178685, y:79.4903784},
    'p-r-5-26': {x: 393.047603, y:76.4841946},
    'p-r-5-27': {x: 402.813034, y:73.1580973},


    'p-l-6-1': {x: 134.177151, y:86.9381622},
    'p-l-6-2': {x: 143.925622, y:90.3137297},
    'p-l-6-3': {x: 153.78208, y:93.3600432},
    'p-l-6-4': {x: 163.727054, y:96.1043459},
    'p-l-6-5': {x: 173.749125, y:98.5523459},
    'p-l-6-6': {x: 183.834965, y:100.723157},
    'p-l-6-7': {x: 193.974712, y:102.626984},
    'p-l-6-8': {x: 204.159625, y:104.272389},
    'p-l-6-9': {x: 214.381832, y:105.667243},
    'p-l-6-10': {x: 224.634497, y:106.818119},
    'p-l-6-11': {x: 234.911129, y:107.730811},
    'p-l-6-12': {x: 245.205846, y:108.410422},
    'p-l-6-13': {x: 255.513108, y:108.861362},
    'p-l-6-14': {x: 265.827813, y:109.087438},
    'p-r-6-15': {x: 276.14494, y:109.088908},
    'p-r-6-16': {x: 286.45973, y:108.86707},
    'p-r-6-17': {x: 296.767166, y:108.420368},
    'p-r-6-18': {x: 307.062142, y:107.745081},
    'p-r-6-19': {x: 317.339121, y:106.8368},
    'p-r-6-20': {x: 327.592304, y:105.690335},
    'p-r-6-21': {x: 337.81529, y:104.299892},
    'p-r-6-22': {x: 348.000809, y:102.658724},
    'p-r-6-23': {x: 358.141335, y:100.759049},
    'p-r-6-24': {x: 368.22804, y:98.5921297},
    'p-r-6-25': {x: 378.250889, y:96.1478486},
    'p-r-6-26': {x: 388.198027, y:93.4110703},
    'p-r-6-27': {x: 398.05535, y:90.3678703},
    'p-r-6-28': {x: 407.806331, y:86.9997405},


    'p-l-7-1': {x: 129.253335, y:101.083373},
    'p-l-7-2': {x: 138.991856, y:104.487481},
    'p-l-7-3': {x: 148.838103, y:107.566573},
    'p-l-7-4': {x: 158.775117, y:110.33907},
    'p-l-7-5': {x: 168.788362, y:112.823135},
    'p-l-7-6': {x: 178.952044, y:114.936822},
    'p-l-7-7': {x: 188.84857, y:116.865144},
    'p-l-7-8': {x: 199.174895, y:118.670659},
    'p-l-7-9': {x: 209.389487, y:120.120432},
    'p-l-7-10': {x: 219.635056, y:121.333405},
    'p-l-7-11': {x: 229.905286, y:122.315719},
    'p-l-7-12': {x: 240.194551, y:123.072822},
    'p-l-7-13': {x: 250.497747, y:123.609211},
    'p-l-7-14': {x: 260.809942, y:123.929038},
    'p-l-7-15': {x: 271.12655, y:124.035589},
    'p-r-7-16': {x: 281.443157, y:123.927049},
    'p-r-7-17': {x: 291.755352, y:123.605059},
    'p-r-7-18': {x: 302.058375, y:123.066508},
    'p-r-7-19': {x: 312.347554, y:122.30733},
    'p-r-7-20': {x: 322.61761, y:121.322941},
    'p-r-7-21': {x: 332.862834, y:120.107805},
    'p-r-7-22': {x: 343.077166, y:118.655784},
    'p-r-7-23': {x: 353.253687, y:116.959438},
    'p-r-7-24': {x: 363.384868, y:115.010638},
    'p-r-7-25': {x: 373.461882, y:112.799784},
    'p-r-7-26': {x: 383.474867, y:110.314249},
    'p-r-7-27': {x: 393.410843, y:107.537773},
    'p-r-7-28': {x: 403.256398, y:104.456605},
    'p-r-7-29': {x: 412.99414, y:101.050076},


    'p-l-8-1': {x: 133.780425, y:117.768778},
    'p-l-8-2': {x: 143.616808, y:120.879265},
    'p-l-8-3': {x: 153.545083, y:123.68307},
    'p-l-8-4': {x: 163.549934, y:126.200692},
    'p-l-8-5': {x: 173.619507, y:128.445795},
    'p-l-8-6': {x: 183.743419, y:130.432043},
    'p-l-8-7': {x: 193.912585, y:132.171978},
    'p-l-8-8': {x: 204.119563, y:133.674335},
    'p-l-8-9': {x: 214.357951, y:134.946811},
    'p-l-8-10': {x: 224.621518, y:135.995978},
    'p-l-8-11': {x: 234.905072, y:136.827632},
    'p-l-8-12': {x: 245.203682, y:137.446616},
    'p-l-8-13': {x: 255.512676, y:137.857254},
    'p-l-8-14': {x: 265.827813, y:138.063005},
    'p-r-8-15': {x: 276.14494, y:138.064389},
    'p-r-8-16': {x: 286.460163, y:137.862443},
    'p-r-8-17': {x: 296.769329, y:137.455697},
    'p-r-8-18': {x: 307.068113, y:136.840605},
    'p-r-8-19': {x: 317.352013, y:136.013016},
    'p-r-8-20': {x: 327.616013, y:134.967827},
    'p-r-8-21': {x: 337.854919, y:133.69933},
    'p-r-8-22': {x: 348.062416, y:132.200951},
    'p-r-8-23': {x: 358.232361, y:130.464822},
    'p-r-8-24': {x: 368.356879, y:128.482032},
    'p-r-8-25': {x: 378.428096, y:126.244022},
    'p-r-8-26': {x: 388.433726, y:123.729514},
    'p-r-8-27': {x: 398.364078, y:120.9328},
    'p-r-8-28': {x: 408.201153, y:117.824735},


    'p-l-9-1': {x: 138.885947, y:134.560908},
    'p-l-9-2': {x: 148.77191, y:137.510357},
    'p-l-9-3': {x: 158.741804, y:140.162811},
    'p-l-9-4': {x: 168.781613, y:142.537211},
    'p-l-9-5': {x: 178.880778, y:144.645578},
    'p-l-9-6': {x: 189.029091, y:146.502789},
    'p-l-9-7': {x: 199.21885, y:148.118184},
    'p-l-9-8': {x: 209.442961, y:149.500151},
    'p-l-9-9': {x: 219.695106, y:150.655697},
    'p-l-9-10': {x: 229.969835, y:151.590962},
    'p-l-9-11': {x: 240.261782, y:152.311222},
    'p-l-9-12': {x: 250.566276, y:152.821146},
    'p-l-9-13': {x: 260.87899, y:153.124541},
    'p-l-9-14': {x: 271.195771, y:153.224605},
    'p-r-9-15': {x: 281.512379, y:153.120043},
    'p-r-9-16': {x: 291.82492, y:152.811719},
    'p-r-9-17': {x: 302.129241, y:152.296865},
    'p-r-9-18': {x: 312.420843, y:151.571676},
    'p-r-9-19': {x: 322.695052, y:150.631395},
    'p-r-9-20': {x: 332.946678, y:149.470832},
    'p-r-9-21': {x: 343.170096, y:148.083676},
    'p-r-9-22': {x: 353.358904, y:146.462746},
    'p-r-9-23': {x: 363.506265, y:144.599741},
    'p-r-9-24': {x: 373.604046, y:142.485059},
    'p-r-9-25': {x: 383.642556, y:140.105038},
    'p-r-9-26': {x: 393.610374, y:137.445319},
    'p-r-9-27': {x: 403.494347, y:134.489297},


    'p-l-10-1': {x: 143.354545, y:151.922032},
    'p-l-10-2': {x: 153.316219, y:154.605016},
    'p-l-10-3': {x: 163.348586, y:157.010724},
    'p-l-10-4': {x: 173.44005, y:159.155589},
    'p-l-10-5': {x: 183.581268, y:161.051286},
    'p-l-10-6': {x: 193.763846, y:162.711135},
    'p-l-10-7': {x: 203.980947, y:164.144043},
    'p-l-10-8': {x: 214.22643, y:165.357535},
    'p-l-10-9': {x: 224.494929, y:166.358184},
    'p-l-10-10': {x: 234.781512, y:167.151697},
    'p-l-10-11': {x: 245.081679, y:167.742832},
    'p-l-10-12': {x: 255.391451, y:168.135654},
    'p-l-10-13': {x: 265.706761, y:168.333708},
    'p-r-10-14': {x: 276.023975, y:168.336822},
    'p-r-10-15': {x: 286.339371, y:168.147243},
    'p-r-10-16': {x: 296.649403, y:167.762897},
    'p-r-10-17': {x: 306.950176, y:167.180497},
    'p-r-10-18': {x: 317.237451, y:166.395719},
    'p-r-10-19': {x: 327.506643, y:165.403805},
    'p-r-10-20': {x: 337.75325, y:164.199135},
    'p-r-10-21': {x: 347.97165, y:162.775135},
    'p-r-10-22': {x: 358.155698, y:161.124022},
    'p-r-10-23': {x: 368.29856, y:159.237059},
    'p-r-10-24': {x: 378.39262, y:157.104043},
    'p-r-10-25': {x: 388.42741, y:154.708714},
    'p-r-10-26': {x: 398.392891, y:152.039741},


    'p-l-11-1': {x: 148.442243, y:167.731849},
    'p-l-11-2': {x: 158.472879, y:170.144908},
    'p-l-11-3': {x: 168.561575, y:172.302919},
    'p-l-11-4': {x: 178.699677, y:174.215481},
    'p-l-11-5': {x: 188.878534, y:175.898335},
    'p-l-11-6': {x: 199.091396, y:177.360908},
    'p-l-11-7': {x: 209.332466, y:178.611243},
    'p-l-11-8': {x: 219.596552, y:179.656259},
    'p-l-11-9': {x: 229.878981, y:180.501924},
    'p-l-11-10': {x: 240.175601, y:181.153254},
    'p-l-11-11': {x: 250.482432, y:181.614659},
    'p-l-11-12': {x: 260.796011, y:181.889773},
    'p-l-11-13': {x: 271.112792, y:181.981622},
    'p-r-11-14': {x: 281.429659, y:181.888562},
    'p-r-11-15': {x: 291.743152, y:181.612065},
    'p-r-11-16': {x: 302.049982, y:181.149362},
    'p-r-11-17': {x: 312.346516, y:180.496735},
    'p-r-11-18': {x: 322.628859, y:179.649859},
    'p-r-11-19': {x: 332.892685, y:178.603459},
    'p-r-11-20': {x: 343.133669, y:177.351654},
    'p-r-11-21': {x: 353.346271, y:175.887438},
    'p-r-11-22': {x: 363.524782, y:174.202681},
    'p-r-11-23': {x: 373.662452, y:172.28787},
    'p-r-11-24': {x: 383.751061, y:170.129168},
    'p-r-11-25': {x: 393.780919, y:167.713081},


    'p-l-12-1': {x: 173.30628, y:188.580281},
    'p-l-12-2': {x: 183.464543, y:190.383524},
    'p-l-12-3': {x: 193.6601, y:191.96173},
    'p-l-12-4': {x: 203.886893, y:193.323719},
    'p-l-12-5': {x: 214.139297, y:194.477016},
    'p-l-12-6': {x: 224.412555, y:195.428022},
    'p-l-12-7': {x: 234.702166, y:196.182097},
    'p-l-12-8': {x: 245.003978, y:196.744259},
    'p-l-12-9': {x: 255.314443, y:197.118227},
    'p-l-12-10': {x: 265.629925, y:197.307459},
    'p-r-12-11': {x: 275.947139, y:197.311524},
    'p-r-12-12': {x: 286.262795, y:197.133189},
    'p-r-12-13': {x: 296.573605, y:196.770292},
    'p-r-12-14': {x: 306.876109, y:196.219286},
    'p-r-12-15': {x: 317.166499, y:195.476368},
    'p-r-12-16': {x: 327.440796, y:194.536778},
    'p-r-12-17': {x: 337.694498, y:193.394897},
    'p-r-12-18': {x: 347.922849, y:192.044411},
    'p-r-12-19': {x: 358.120222, y:190.477622},
    'p-r-12-20': {x: 368.280476, y:188.685968},


    'p-l-13-1': {x: 209.248189, y:208.223265},
    'p-l-13-2': {x: 219.512101, y:209.270011},
    'p-l-13-3': {x: 229.794445, y:210.117232},
    'p-l-13-4': {x: 240.090978, y:210.770292},
    'p-l-13-5': {x: 250.397722, y:211.233341},
    'p-l-13-6': {x: 260.711215, y:211.510011},
    'p-l-13-7': {x: 271.028082, y:211.603416},
    'p-r-13-8': {x: 281.344863, y:211.511568},
    'p-r-13-9': {x: 291.658356, y:211.236714},
    'p-r-13-10': {x: 301.965272, y:210.775654},
    'p-r-13-11': {x: 312.261893, y:210.12467},
    'p-r-13-12': {x: 322.544409, y:209.279351},
    'p-r-13-13': {x: 332.808581, y:208.234681},


    'p-l-14-1': {x: 224.53975, y:224.506941},
    'p-l-14-2': {x: 234.795875, y:225.219676},
    'p-l-14-3': {x: 245.072248, y:225.750616},
    'p-l-14-4': {x: 255.36532, y:226.103654},
    'p-l-14-5': {x: 265.671891, y:226.282076},
    'p-r-14-6': {x: 275.988931, y:226.285535},
    'p-r-14-7': {x: 286.313413, y:226.116454},
    'p-r-14-8': {x: 296.642394, y:225.77267},
    'p-r-14-9': {x: 306.973366, y:225.251157},
    'p-r-14-10': {x: 317.30252, y:224.547935},


    //MEZANIN
    'm-l-1-1': {x: 92, y:4},
    'm-l-1-2': {x: 92, y:16},
    'm-l-1-3': {x: 82, y:4},
    'm-l-1-4': {x: 82, y:16},
    'm-l-1-5': {x: 72, y:16},

    'm-l-2-1': {x: 92, y:41},
    'm-l-2-2': {x: 92, y:53},
    'm-l-2-3': {x: 82, y:41},
    'm-l-2-4': {x: 82, y:53},
    'm-l-2-5': {x: 72, y:53},

    'm-l-3-1': {x: 92, y:78},
    'm-l-3-2': {x: 92, y:90},
    'm-l-3-3': {x: 82, y:78},
    'm-l-3-4': {x: 82, y:90},
    'm-l-3-5': {x: 72, y:90},

    'm-l-4-1': {x: 92, y:116},
    'm-l-4-2': {x: 92, y:128},
    'm-l-4-3': {x: 82, y:116},
    'm-l-4-4': {x: 82, y:128},
    'm-l-4-5': {x: 72, y:128},

    'm-l-5-1': {x: 91.7, y:154.9},
    'm-l-5-2': {x: 92.9, y:166.9},
    'm-l-5-3': {x: 81.7, y:156},
    'm-l-5-4': {x: 83, y:167.9},
    'm-l-5-5': {x: 73, y:169},

    'm-l-6-1': {x: 98.2, y:192.4},
    'm-l-6-2': {x: 103.6, y:203.1},
    'm-l-6-3': {x: 89.3, y:196.9},
    'm-l-6-4': {x: 94.7, y:207.6},
    'm-l-6-5': {x: 85.8, y:212.2},

    'm-l-7-1': {x: 116.3, y:227.7},
    'm-l-7-2': {x: 125.1, y:235.8},
    'm-l-7-3': {x: 109.5, y:235},
    'm-l-7-4': {x: 118.2, y:243.2},
    'm-l-7-5': {x: 102.7, y:242.3},

    'm-l-8-1': {x: 150, y:250.1},
    'm-l-8-2': {x: 161.2, y:254.2},
    'm-l-8-3': {x: 146.5, y:259.5},
    'm-l-8-4': {x: 157.8, y:263.6},
    'm-l-8-5': {x: 143.1, y:268.9},

    'm-l-9-1': {x: 189.3, y:260.5},
    'm-l-9-2': {x: 201.2, y:262.2},
    'm-l-9-3': {x: 187.9, y:270.4},
    'm-l-9-4': {x: 199.8, y:272.1},
    'm-l-9-5': {x: 186.5, y:280.3},

    'm-l-10-1': {x: 228, y:266},
    'm-l-10-2': {x: 240, y:266},
    'm-l-10-3': {x: 228, y:276},
    'm-l-10-4': {x: 240, y:276},
    'm-l-10-5': {x: 228, y:286},

    'm-l-11-1': {x: 266, y:266},
    'm-l-11-2': {x: 278, y:266},
    'm-l-11-3': {x: 266, y:276},
    'm-l-11-4': {x: 278, y:276},
    'm-l-11-5': {x: 266, y:286},


    'm-r-1-1': {x: 452, y:4},
    'm-r-1-2': {x: 452, y:16},
    'm-r-1-3': {x: 462, y:4},
    'm-r-1-4': {x: 462, y:16},
    'm-r-1-5': {x: 472, y:16},

    'm-r-2-1': {x: 452, y:41},
    'm-r-2-2': {x: 452, y:53},
    'm-r-2-3': {x: 462, y:41},
    'm-r-2-4': {x: 462, y:53},
    'm-r-2-5': {x: 472, y:53},

    'm-r-3-1': {x: 452, y:78},
    'm-r-3-2': {x: 452, y:90},
    'm-r-3-3': {x: 462, y:78},
    'm-r-3-4': {x: 462, y:90},
    'm-r-3-5': {x: 472, y:90},

    'm-r-4-1': {x: 452, y:116},
    'm-r-4-2': {x: 452, y:128},
    'm-r-4-3': {x: 462, y:116},
    'm-r-4-4': {x: 462, y:128},
    'm-r-4-5': {x: 472, y:128},

    'm-r-5-1': {x: 452.3, y:154.9},
    'm-r-5-2': {x: 451.1, y:166.9},
    'm-r-5-3': {x: 462.3, y:156},
    'm-r-5-4': {x: 461, y:167.9},
    'm-r-5-5': {x: 471, y:169},

    'm-r-6-1': {x: 445.8, y:192.4},
    'm-r-6-2': {x: 440.4, y:203.1},
    'm-r-6-3': {x: 454.7, y:196.9},
    'm-r-6-4': {x: 449.3, y:207.6},
    'm-r-6-5': {x: 458.2, y:212.2},

    'm-r-7-1': {x: 418.7, y:235.8},
    'm-r-7-2': {x: 427.4, y:227.7},
    'm-r-7-3': {x: 425.5, y:243.2},
    'm-r-7-4': {x: 434.2, y:235},
    'm-r-7-5': {x: 432.3, y:250.5},

    'm-r-8-1': {x: 383.1, y:255.2},
    'm-r-8-2': {x: 394.4, y:251.1},
    'm-r-8-3': {x: 386.5, y:264.6},
    'm-r-8-4': {x: 397.8, y:260.5},
    'm-r-8-5': {x: 390, y:274},

    'm-r-9-1': {x: 343.5, y:263.2},
    'm-r-9-2': {x: 355.4, y:261.5},
    'm-r-9-3': {x: 344.9, y:273.1},
    'm-r-9-4': {x: 356.8, y:271.4},
    'm-r-9-5': {x: 346.3, y:283},

    'm-r-10-1': {x: 304, y:266},
    'm-r-10-2': {x: 316, y:266},
    'm-r-10-3': {x: 304, y:276},
    'm-r-10-4': {x: 316, y:276},
    'm-r-10-5': {x: 304, y:286},


    //1. KAT
    'k-l-1-1': {x: 50, y:4},
    'k-l-1-2': {x: 50, y:16},
    'k-l-1-3': {x: 40, y:4},
    'k-l-1-4': {x: 40, y:16},
    'k-l-1-5': {x: 30, y:16},

    'k-l-2-1': {x: 50, y:41},
    'k-l-2-2': {x: 50, y:53},
    'k-l-2-3': {x: 40, y:41},
    'k-l-2-4': {x: 40, y:53},
    'k-l-2-5': {x: 30, y:53},

    'k-l-3-1': {x: 50, y:78},
    'k-l-3-2': {x: 50, y:90},
    'k-l-3-3': {x: 40, y:78},
    'k-l-3-4': {x: 40, y:90},
    'k-l-3-5': {x: 30, y:90},

    'k-l-4-1': {x: 50, y:116},
    'k-l-4-2': {x: 50, y:128},
    'k-l-4-3': {x: 40, y:116},
    'k-l-4-4': {x: 40, y:128},
    'k-l-4-5': {x: 30, y:128},

    'k-l-5-1': {x: 51.1, y:159.7},
    'k-l-5-2': {x: 52.7, y:171.5},
    'k-l-5-3': {x: 41.2, y:161.1},
    'k-l-5-4': {x: 42.8, y:172.9},
    'k-l-5-5': {x: 32.9, y:174.3},

    'k-l-6-1': {x: 63.2, y:210.4},
    'k-l-6-2': {x: 68.6, y:221.1},
    'k-l-6-3': {x: 54.3, y:214.9},
    'k-l-6-4': {x: 59.7, y:225.6},
    'k-l-6-5': {x: 50.8, y:230.2},

    'k-l-7-1': {x: 90.3, y:257.7},
    'k-l-7-2': {x: 99.1, y:265.8},
    'k-l-7-3': {x: 83.5, y:265},
    'k-l-7-4': {x: 92.2, y:273.2},
    'k-l-7-5': {x: 76.7, y:272.3},

    'k-l-8-1': {x: 136, y:288.1},
    'k-l-8-2': {x: 147.2, y:292.2},
    'k-l-8-3': {x: 132.5, y:297.5},
    'k-l-8-4': {x: 143.8, y:301.6},
    'k-l-8-5': {x: 129.1, y:306.9},

    'k-l-9-1': {x: 183.3, y:300.5},
    'k-l-9-2': {x: 195.2, y:302.2},
    'k-l-9-3': {x: 181.9, y:310.4},
    'k-l-9-4': {x: 193.8, y:312.1},
    'k-l-9-5': {x: 180.5, y:320.3},

    'k-l-10-1': {x: 228, y:305},
    'k-l-10-2': {x: 240, y:305},
    'k-l-10-3': {x: 228, y:315},
    'k-l-10-4': {x: 240, y:315},
    'k-l-10-5': {x: 228, y:325},

    'k-l-11-1': {x: 266, y:305},
    'k-l-11-2': {x: 278, y:305},
    'k-l-11-3': {x: 266, y:315},
    'k-l-11-4': {x: 278, y:315},
    'k-l-11-5': {x: 266, y:325},

    'k-r-1-1': {x: 494, y:4},
    'k-r-1-2': {x: 494, y:16},
    'k-r-1-3': {x: 504, y:4},
    'k-r-1-4': {x: 504, y:16},
    'k-r-1-5': {x: 514, y:16},

    'k-r-2-1': {x: 494, y:41},
    'k-r-2-2': {x: 494, y:53},
    'k-r-2-3': {x: 504, y:41},
    'k-r-2-4': {x: 504, y:53},
    'k-r-2-5': {x: 514, y:53},

    'k-r-3-1': {x: 494, y:78},
    'k-r-3-2': {x: 494, y:90},
    'k-r-3-3': {x: 504, y:78},
    'k-r-3-4': {x: 504, y:90},
    'k-r-3-5': {x: 514, y:90},

    'k-r-4-1': {x: 494, y:116},
    'k-r-4-2': {x: 494, y:128},
    'k-r-4-3': {x: 504, y:116},
    'k-r-4-4': {x: 504, y:128},
    'k-r-4-5': {x: 514, y:128},

    'k-r-5-1': {x: 492.9, y:159.7},
    'k-r-5-2': {x: 491.3, y:171.5},
    'k-r-5-3': {x: 502.8, y:161.1},
    'k-r-5-4': {x: 501.2, y:172.9},
    'k-r-5-5': {x: 511.1, y:174.3},

    'k-r-6-1': {x: 480.8, y:210.4},
    'k-r-6-2': {x: 475.4, y:221.1},
    'k-r-6-3': {x: 489.7, y:214.9},
    'k-r-6-4': {x: 484.3, y:225.6},
    'k-r-6-5': {x: 493.2, y:230.2},

    'k-r-7-1': {x: 444.7, y:264.8},
    'k-r-7-2': {x: 453.4, y:256.7},
    'k-r-7-3': {x: 451.5, y:272.2},
    'k-r-7-4': {x: 460.2, y:264},
    'k-r-7-5': {x: 458.3, y:279.5},

    'k-r-8-1': {x: 396.1, y:292.2},
    'k-r-8-2': {x: 407.4, y:288.1},
    'k-r-8-3': {x: 399.5, y:301.6},
    'k-r-8-4': {x: 410.8, y:297.5},
    'k-r-8-5': {x: 403, y:311},

    'k-r-9-1': {x: 347.5, y:302.2},
    'k-r-9-2': {x: 359.4, y:300.5},
    'k-r-9-3': {x: 348.9, y:312.1},
    'k-r-9-4': {x: 360.8, y:310.4},
    'k-r-9-5': {x: 350.3, y:322},

    'k-r-10-1': {x: 304, y:305},
    'k-r-10-2': {x: 316, y:305},
    'k-r-10-3': {x: 304, y:315},
    'k-r-10-4': {x: 316, y:315},
    'k-r-10-5': {x: 304, y:325},


    //BALKON
    'lb-l-2-1': {x: 4, y:73},
    'lb-l-2-2': {x: 4, y:88},
    'lb-l-2-3': {x: 4, y:103},
    'lb-l-3-1': {x: 4, y:135},
    'lb-l-3-2': {x: 4, y:150},
    'lb-l-3-3': {x: 4, y:165},
    'lb-l-3-4': {x: 4, y:180},

    'lb-r-2-1': {x: 540, y:73},
    'lb-r-2-2': {x: 540, y:88},
    'lb-r-2-3': {x: 540, y:103},
    'lb-r-3-1': {x: 540, y:135},
    'lb-r-3-2': {x: 540, y:150},
    'lb-r-3-3': {x: 540, y:165},
    'lb-r-3-4': {x: 540, y:180},

    'b-l-1-1': {x: 81, y:325},
    'b-l-1-2': {x: 95, y:333},
    'b-l-1-3': {x: 109, y:341},
    'b-l-1-4': {x: 123, y:347},
    'b-l-1-5': {x: 137, y:353},
    'b-l-1-6': {x: 152, y:357},
    'b-l-1-7': {x: 167, y:361},
    'b-l-1-8': {x: 182, y:362},
    'b-l-1-9': {x: 197, y:363},
    'b-l-1-10': {x: 212, y:364},
    'b-l-1-11': {x: 227, y:364},
    'b-l-1-12': {x: 242, y:364},
    'b-l-1-13': {x: 257, y:364},
    'b-l-1-14': {x: 272, y:364},
    'b-r-1-15': {x: 287, y:364},
    'b-r-1-16': {x: 302, y:364},
    'b-r-1-17': {x: 317, y:364},
    'b-r-1-18': {x: 332, y:364},
    'b-r-1-19': {x: 347, y:363},
    'b-r-1-20': {x: 362, y:362},
    'b-r-1-21': {x: 377, y:361},
    'b-r-1-22': {x: 392, y:357},
    'b-r-1-23': {x: 407, y:353},
    'b-r-1-24': {x: 421, y:347},
    'b-r-1-25': {x: 435, y:341},
    'b-r-1-26': {x: 449, y:333},
    'b-r-1-27': {x: 463, y:325},


    'b-l-2-1': {x: 53, y:337-10},
    'b-l-2-2': {x: 67, y:345-10},
    'b-l-2-3': {x: 81, y:353-10},
    'b-l-2-4': {x: 95, y:361-10},
    'b-l-2-5': {x: 109, y:369-10},
    'b-l-2-6': {x: 123, y:375-10},
    'b-l-2-7': {x: 137, y:381-10},
    'b-l-2-8': {x: 152, y:385-10},
    'b-l-2-9': {x: 167, y:389-10},
    'b-l-2-10': {x: 182, y:390-10},
    'b-l-2-11': {x: 197, y:391-10},
    'b-l-2-12': {x: 212, y:392-10},
    'b-l-2-13': {x: 227, y:392-10},
    'b-l-2-14': {x: 242, y:392-10},
    'b-l-2-15': {x: 257, y:392-10},
    'b-l-2-16': {x: 272, y:392-10},
    'b-r-2-17': {x: 287, y:392-10},
    'b-r-2-18': {x: 302, y:392-10},
    'b-r-2-19': {x: 317, y:392-10},
    'b-r-2-20': {x: 332, y:392-10},
    'b-r-2-21': {x: 347, y:391-10},
    'b-r-2-22': {x: 362, y:390-10},
    'b-r-2-23': {x: 377, y:389-10},
    'b-r-2-24': {x: 392, y:385-10},
    'b-r-2-25': {x: 407, y:381-10},
    'b-r-2-26': {x: 421, y:375-10},
    'b-r-2-27': {x: 435, y:369-10},
    'b-r-2-28': {x: 449, y:361-10},
    'b-r-2-29': {x: 463, y:353-10},
    'b-r-2-30': {x: 477, y:345-10},
    'b-r-2-31': {x: 491, y:337-10},


    'b-l-3-1': {x: 39, y:357-20},
    'b-l-3-2': {x: 53, y:365-20},
    'b-l-3-3': {x: 67, y:373-20},
    'b-l-3-4': {x: 81, y:381-20},
    'b-l-3-5': {x: 95, y:389-20},
    'b-l-3-6': {x: 109, y:397-20},
    'b-l-3-7': {x: 123, y:403-20},
    'b-l-3-8': {x: 137, y:409-20},
    'b-l-3-9': {x: 152, y:413-20},
    'b-l-3-10': {x: 167, y:417-20},
    'b-l-3-11': {x: 182, y:418-20},
    'b-l-3-12': {x: 197, y:419-20},
    'b-l-3-13': {x: 212, y:420-20},
    'b-l-3-14': {x: 227, y:420-20},
    'b-l-3-15': {x: 242, y:420-20},
    'b-l-3-16': {x: 257, y:420-20},
    'b-l-3-17': {x: 272, y:420-20},
    'b-r-3-18': {x: 287, y:420-20},
    'b-r-3-19': {x: 302, y:420-20},
    'b-r-3-20': {x: 317, y:420-20},
    'b-r-3-21': {x: 332, y:420-20},
    'b-r-3-22': {x: 347, y:419-20},
    'b-r-3-23': {x: 362, y:418-20},
    'b-r-3-24': {x: 377, y:417-20},
    'b-r-3-25': {x: 392, y:413-20},
    'b-r-3-26': {x: 407, y:409-20},
    'b-r-3-27': {x: 421, y:403-20},
    'b-r-3-28': {x: 435, y:397-20},
    'b-r-3-29': {x: 449, y:389-20},
    'b-r-3-30': {x: 463, y:381-20},
    'b-r-3-31': {x: 477, y:373-20},
    'b-r-3-32': {x: 491, y:365-20},
    'b-r-3-33': {x: 505, y:357-20},


    'b-l-4-1': {x: 78, y:416-30},
    'b-l-4-2': {x: 93, y:424-30},
    'b-l-4-3': {x: 108, y:432-30},
    'b-l-4-4': {x: 123, y:438-30},
    'b-l-4-5': {x: 182, y:446-30},
    'b-l-4-6': {x: 197, y:447-30},
    'b-l-4-7': {x: 212, y:448-30},
    'b-l-4-8': {x: 227, y:448-30},
    'b-l-4-9': {x: 242, y:448-30},
    'b-l-4-10': {x: 257, y:448-30},
    'b-l-4-11': {x: 272, y:448-30},
    'b-r-4-12': {x: 287, y:448-30},
    'b-r-4-13': {x: 302, y:448-30},
    'b-r-4-14': {x: 317, y:448-30},
    'b-r-4-15': {x: 332, y:448-30},
    'b-r-4-16': {x: 347, y:447-30},
    'b-r-4-17': {x: 362, y:446-30},
    'b-r-4-18': {x: 421, y:438-30},
    'b-r-4-19': {x: 436, y:432-30},
    'b-r-4-20': {x: 451, y:424-30},
    'b-r-4-21': {x: 466, y:416-30},


    'b-l-5-1': {x: 48, y:429-40},
    'b-l-5-2': {x: 62, y:437-40},
    'b-l-5-3': {x: 76, y:445-40},
    'b-l-5-4': {x: 90, y:453-40},
    'b-l-5-5': {x: 104, y:459-40},
    'b-l-5-6': {x: 118, y:465-40},
    'b-l-5-7': {x: 160, y:473-40},
    'b-l-5-8': {x: 175, y:474-40},
    'b-l-5-9': {x: 190, y:475-40},
    'b-l-5-10': {x: 205, y:476-40},
    'b-l-5-11': {x: 220, y:476-40},
    'b-l-5-12': {x: 235, y:476-40},
    'b-l-5-13': {x: 250, y:476-40},
    'b-l-5-14': {x: 265, y:476-40},
    'b-r-5-15': {x: 280, y:476-40},
    'b-r-5-16': {x: 295, y:476-40},
    'b-r-5-17': {x: 310, y:476-40},
    'b-r-5-18': {x: 325, y:476-40},
    'b-r-5-19': {x: 340, y:476-40},
    'b-r-5-20': {x: 355, y:475-40},
    'b-r-5-21': {x: 370, y:474-40},
    'b-r-5-22': {x: 385, y:473-40},
    'b-r-5-23': {x: 427, y:465-40},
    'b-r-5-24': {x: 441, y:459-40},
    'b-r-5-25': {x: 455, y:453-40},
    'b-r-5-26': {x: 469, y:445-40},
    'b-r-5-27': {x: 483, y:437-40},
    'b-r-5-28': {x: 497, y:429-40},


    //MUZICKA AKADEMIJA
    'ma-l-1-1': {x: 160, y: 105},
    'ma-l-1-2': {x: 170, y: 105},
    'ma-l-1-3': {x: 180, y: 105},
    'ma-l-1-4': {x: 190, y: 105},
    'ma-l-1-5': {x: 200, y: 105},
    'ma-l-1-6': {x: 210, y: 105},
    'ma-l-1-7': {x: 220, y: 105},
    'ma-l-1-8': {x: 230, y: 105},
    'ma-l-1-9': {x: 240, y: 105},
    'ma-l-1-10': {x: 250, y: 105},
    'ma-l-1-11': {x: 260, y: 105},
    'ma-l-1-12': {x: 270, y: 105},

    'ma-r-1-13': {x: 280, y: 105},
    'ma-r-1-14': {x: 290, y: 105},
    'ma-r-1-15': {x: 300, y: 105},
    'ma-r-1-16': {x: 310, y: 105},
    'ma-r-1-17': {x: 320, y: 105},
    'ma-r-1-18': {x: 330, y: 105},
    'ma-r-1-19': {x: 340, y: 105},
    'ma-r-1-20': {x: 350, y: 105},
    'ma-r-1-21': {x: 360, y: 105},
    'ma-r-1-22': {x: 370, y: 105},
    'ma-r-1-23': {x: 380, y: 105},
    'ma-r-1-24': {x: 390, y: 105},



    'ma-l-2-1': {x: 160, y: 120},
    'ma-l-2-2': {x: 170, y: 120},
    'ma-l-2-3': {x: 180, y: 120},
    'ma-l-2-4': {x: 190, y: 120},
    'ma-l-2-5': {x: 200, y: 120},
    'ma-l-2-6': {x: 210, y: 120},
    'ma-l-2-7': {x: 220, y: 120},
    'ma-l-2-8': {x: 230, y: 120},
    'ma-l-2-9': {x: 240, y: 120},
    'ma-l-2-10': {x: 250, y: 120},
    'ma-l-2-11': {x: 260, y: 120},
    'ma-l-2-12': {x: 270, y: 120},

    'ma-r-2-13': {x: 280, y: 120},
    'ma-r-2-14': {x: 290, y: 120},
    'ma-r-2-15': {x: 300, y: 120},
    'ma-r-2-16': {x: 310, y: 120},
    'ma-r-2-17': {x: 320, y: 120},
    'ma-r-2-18': {x: 330, y: 120},
    'ma-r-2-19': {x: 340, y: 120},
    'ma-r-2-20': {x: 350, y: 120},
    'ma-r-2-21': {x: 360, y: 120},
    'ma-r-2-22': {x: 370, y: 120},
    'ma-r-2-23': {x: 380, y: 120},
    'ma-r-2-24': {x: 390, y: 120},



    'ma-l-3-1': {x: 160, y: 135},
    'ma-l-3-2': {x: 170, y: 135},
    'ma-l-3-3': {x: 180, y: 135},
    'ma-l-3-4': {x: 190, y: 135},
    'ma-l-3-5': {x: 200, y: 135},
    'ma-l-3-6': {x: 210, y: 135},
    'ma-l-3-7': {x: 220, y: 135},
    'ma-l-3-8': {x: 230, y: 135},
    'ma-l-3-9': {x: 240, y: 135},
    'ma-l-3-10': {x: 250, y: 135},
    'ma-l-3-11': {x: 260, y: 135},
    'ma-l-3-12': {x: 270, y: 135},

    'ma-r-3-13': {x: 280, y: 135},
    'ma-r-3-14': {x: 290, y: 135},
    'ma-r-3-15': {x: 300, y: 135},
    'ma-r-3-16': {x: 310, y: 135},
    'ma-r-3-17': {x: 320, y: 135},
    'ma-r-3-18': {x: 330, y: 135},
    'ma-r-3-19': {x: 340, y: 135},
    'ma-r-3-20': {x: 350, y: 135},
    'ma-r-3-21': {x: 360, y: 135},
    'ma-r-3-22': {x: 370, y: 135},
    'ma-r-3-23': {x: 380, y: 135},
    'ma-r-3-24': {x: 390, y: 135},


    'ma-l-4-1': {x: 160, y: 150},
    'ma-l-4-2': {x: 170, y: 150},
    'ma-l-4-3': {x: 180, y: 150},
    'ma-l-4-4': {x: 190, y: 150},
    'ma-l-4-5': {x: 200, y: 150},
    'ma-l-4-6': {x: 210, y: 150},
    'ma-l-4-7': {x: 220, y: 150},
    'ma-l-4-8': {x: 230, y: 150},
    'ma-l-4-9': {x: 240, y: 150},
    'ma-l-4-10': {x: 250, y: 150},
    'ma-l-4-11': {x: 260, y: 150},
    'ma-l-4-12': {x: 270, y: 150},

    'ma-r-4-13': {x: 280, y: 150},
    'ma-r-4-14': {x: 290, y: 150},
    'ma-r-4-15': {x: 300, y: 150},
    'ma-r-4-16': {x: 310, y: 150},
    'ma-r-4-17': {x: 320, y: 150},
    'ma-r-4-18': {x: 330, y: 150},
    'ma-r-4-19': {x: 340, y: 150},
    'ma-r-4-20': {x: 350, y: 150},
    'ma-r-4-21': {x: 360, y: 150},
    'ma-r-4-22': {x: 370, y: 150},
    'ma-r-4-23': {x: 380, y: 150},
    'ma-r-4-24': {x: 390, y: 150},



    'ma-l-5-1': {x: 155, y: 165},
    'ma-l-5-2': {x: 165, y: 165},
    'ma-l-5-3': {x: 175, y: 165},
    'ma-l-5-4': {x: 185, y: 165},
    'ma-l-5-5': {x: 195, y: 165},
    'ma-l-5-6': {x: 205, y: 165},
    'ma-l-5-7': {x: 215, y: 165},
    'ma-l-5-8': {x: 225, y: 165},
    'ma-l-5-9': {x: 235, y: 165},
    'ma-l-5-10': {x: 245, y: 165},
    'ma-l-5-11': {x: 255, y: 165},
    'ma-l-5-12': {x: 265, y: 165},
    'ma-l-5-13': {x: 275, y: 165},

    'ma-r-5-14': {x: 285, y: 165},
    'ma-r-5-15': {x: 295, y: 165},
    'ma-r-5-16': {x: 305, y: 165},
    'ma-r-5-17': {x: 315, y: 165},
    'ma-r-5-18': {x: 325, y: 165},
    'ma-r-5-19': {x: 335, y: 165},
    'ma-r-5-20': {x: 345, y: 165},
    'ma-r-5-21': {x: 355, y: 165},
    'ma-r-5-22': {x: 365, y: 165},
    'ma-r-5-23': {x: 375, y: 165},
    'ma-r-5-24': {x: 385, y: 165},
    'ma-r-5-25': {x: 395, y: 165},



    'ma-l-6-1': {x: 155, y: 180},
    'ma-l-6-2': {x: 165, y: 180},
    'ma-l-6-3': {x: 175, y: 180},
    'ma-l-6-4': {x: 185, y: 180},
    'ma-l-6-5': {x: 195, y: 180},
    'ma-l-6-6': {x: 205, y: 180},
    'ma-l-6-7': {x: 215, y: 180},
    'ma-l-6-8': {x: 225, y: 180},
    'ma-l-6-9': {x: 235, y: 180},
    'ma-l-6-10': {x: 245, y: 180},
    'ma-l-6-11': {x: 255, y: 180},
    'ma-l-6-12': {x: 265, y: 180},
    'ma-l-6-13': {x: 275, y: 180},

    'ma-r-6-14': {x: 285, y: 180},
    'ma-r-6-15': {x: 295, y: 180},
    'ma-r-6-16': {x: 305, y: 180},
    'ma-r-6-17': {x: 315, y: 180},
    'ma-r-6-18': {x: 325, y: 180},
    'ma-r-6-19': {x: 335, y: 180},
    'ma-r-6-20': {x: 345, y: 180},
    'ma-r-6-21': {x: 355, y: 180},
    'ma-r-6-22': {x: 365, y: 180},
    'ma-r-6-23': {x: 375, y: 180},
    'ma-r-6-24': {x: 385, y: 180},
    'ma-r-6-25': {x: 395, y: 180},



    'ma-l-7-1': {x: 155, y: 195},
    'ma-l-7-2': {x: 165, y: 195},
    'ma-l-7-3': {x: 175, y: 195},
    'ma-l-7-4': {x: 185, y: 195},
    'ma-l-7-5': {x: 195, y: 195},
    'ma-l-7-6': {x: 205, y: 195},
    'ma-l-7-7': {x: 215, y: 195},
    'ma-l-7-8': {x: 225, y: 195},
    'ma-l-7-9': {x: 235, y: 195},
    'ma-l-7-10': {x: 245, y: 195},
    'ma-l-7-11': {x: 255, y: 195},
    'ma-l-7-12': {x: 265, y: 195},
    'ma-l-7-13': {x: 275, y: 195},

    'ma-r-7-14': {x: 285, y: 195},
    'ma-r-7-15': {x: 295, y: 195},
    'ma-r-7-16': {x: 305, y: 195},
    'ma-r-7-17': {x: 315, y: 195},
    'ma-r-7-18': {x: 325, y: 195},
    'ma-r-7-19': {x: 335, y: 195},
    'ma-r-7-20': {x: 345, y: 195},
    'ma-r-7-21': {x: 355, y: 195},
    'ma-r-7-22': {x: 365, y: 195},
    'ma-r-7-23': {x: 375, y: 195},
    'ma-r-7-24': {x: 385, y: 195},
    'ma-r-7-25': {x: 395, y: 195},



    'ma-l-8-1': {x: 155, y: 210},
    'ma-l-8-2': {x: 165, y: 210},
    'ma-l-8-3': {x: 175, y: 210},
    'ma-l-8-4': {x: 185, y: 210},
    'ma-l-8-5': {x: 195, y: 210},
    'ma-l-8-6': {x: 205, y: 210},
    'ma-l-8-7': {x: 215, y: 210},
    'ma-l-8-8': {x: 225, y: 210},
    'ma-l-8-9': {x: 235, y: 210},
    'ma-l-8-10': {x: 245, y: 210},
    'ma-l-8-11': {x: 255, y: 210},
    'ma-l-8-12': {x: 265, y: 210},
    'ma-l-8-13': {x: 275, y: 210},

    'ma-r-8-14': {x: 285, y: 210},
    'ma-r-8-15': {x: 295, y: 210},
    'ma-r-8-16': {x: 305, y: 210},
    'ma-r-8-17': {x: 315, y: 210},
    'ma-r-8-18': {x: 325, y: 210},
    'ma-r-8-19': {x: 335, y: 210},
    'ma-r-8-20': {x: 345, y: 210},
    'ma-r-8-21': {x: 355, y: 210},
    'ma-r-8-22': {x: 365, y: 210},
    'ma-r-8-23': {x: 375, y: 210},
    'ma-r-8-24': {x: 385, y: 210},
    'ma-r-8-25': {x: 395, y: 210},



    'ma-l-9-1': {x: 155, y: 225},
    'ma-l-9-2': {x: 165, y: 225},
    'ma-l-9-3': {x: 175, y: 225},
    'ma-l-9-4': {x: 185, y: 225},
    'ma-l-9-5': {x: 195, y: 225},
    'ma-l-9-6': {x: 205, y: 225},
    'ma-l-9-7': {x: 215, y: 225},
    'ma-l-9-8': {x: 225, y: 225},
    'ma-l-9-9': {x: 235, y: 225},
    'ma-l-9-10': {x: 245, y: 225},
    'ma-l-9-11': {x: 255, y: 225},
    'ma-l-9-12': {x: 265, y: 225},
    'ma-l-9-13': {x: 275, y: 225},

    'ma-r-9-14': {x: 285, y: 225},
    'ma-r-9-15': {x: 295, y: 225},
    'ma-r-9-16': {x: 305, y: 225},
    'ma-r-9-17': {x: 315, y: 225},
    'ma-r-9-18': {x: 325, y: 225},
    'ma-r-9-19': {x: 335, y: 225},
    'ma-r-9-20': {x: 345, y: 225},
    'ma-r-9-21': {x: 355, y: 225},
    'ma-r-9-22': {x: 365, y: 225},
    'ma-r-9-23': {x: 375, y: 225},
    'ma-r-9-24': {x: 385, y: 225},
    'ma-r-9-25': {x: 395, y: 225},



    'ma-l-10-1': {x: 155, y: 240},
    'ma-l-10-2': {x: 165, y: 240},
    'ma-l-10-3': {x: 175, y: 240},
    'ma-l-10-4': {x: 185, y: 240},
    'ma-l-10-5': {x: 195, y: 240},
    'ma-l-10-6': {x: 205, y: 240},
    'ma-l-10-7': {x: 215, y: 240},
    'ma-l-10-8': {x: 225, y: 240},
    'ma-l-10-9': {x: 235, y: 240},
    'ma-l-10-10': {x: 245, y: 240},
    'ma-l-10-11': {x: 255, y: 240},
    'ma-l-10-12': {x: 265, y: 240},
    'ma-l-10-13': {x: 275, y: 240},

    'ma-r-10-14': {x: 285, y: 240},
    'ma-r-10-15': {x: 295, y: 240},
    'ma-r-10-16': {x: 305, y: 240},
    'ma-r-10-17': {x: 315, y: 240},
    'ma-r-10-18': {x: 325, y: 240},
    'ma-r-10-19': {x: 335, y: 240},
    'ma-r-10-20': {x: 345, y: 240},
    'ma-r-10-21': {x: 355, y: 240},
    'ma-r-10-22': {x: 365, y: 240},
    'ma-r-10-23': {x: 375, y: 240},
    'ma-r-10-24': {x: 385, y: 240},
    'ma-r-10-25': {x: 395, y: 240},



    'ma-l-11-1': {x: 155, y: 255},
    'ma-l-11-2': {x: 165, y: 255},
    'ma-l-11-3': {x: 175, y: 255},
    'ma-l-11-4': {x: 185, y: 255},
    'ma-l-11-5': {x: 195, y: 255},
    'ma-l-11-6': {x: 205, y: 255},
    'ma-l-11-7': {x: 215, y: 255},
    'ma-l-11-8': {x: 225, y: 255},
    'ma-l-11-9': {x: 235, y: 255},
    'ma-l-11-10': {x: 245, y: 255},
    'ma-l-11-11': {x: 255, y: 255},
    'ma-l-11-12': {x: 265, y: 255},
    'ma-l-11-13': {x: 275, y: 255},

    'ma-r-11-14': {x: 285, y: 255},
    'ma-r-11-15': {x: 295, y: 255},
    'ma-r-11-16': {x: 305, y: 255},
    'ma-r-11-17': {x: 315, y: 255},
    'ma-r-11-18': {x: 325, y: 255},
    'ma-r-11-19': {x: 335, y: 255},
    'ma-r-11-20': {x: 345, y: 255},
    'ma-r-11-21': {x: 355, y: 255},
    'ma-r-11-22': {x: 365, y: 255},
    'ma-r-11-23': {x: 375, y: 255},
    'ma-r-11-24': {x: 385, y: 255},
    'ma-r-11-25': {x: 395, y: 255},



    'ma-l-12-1': {x: 160, y: 270},
    'ma-l-12-2': {x: 170, y: 270},
    'ma-l-12-3': {x: 180, y: 270},
    'ma-l-12-4': {x: 190, y: 270},
    'ma-l-12-5': {x: 200, y: 270},
    'ma-l-12-6': {x: 210, y: 270},
    'ma-l-12-7': {x: 220, y: 270},
    'ma-l-12-8': {x: 230, y: 270},
    'ma-l-12-9': {x: 240, y: 270},
    'ma-l-12-10': {x: 250, y: 270},
    'ma-l-12-11': {x: 260, y: 270},
    'ma-l-12-12': {x: 270, y: 270},

    'ma-r-12-13': {x: 280, y: 270},
    'ma-r-12-14': {x: 290, y: 270},
    'ma-r-12-15': {x: 300, y: 270},
    'ma-r-12-16': {x: 310, y: 270},
    'ma-r-12-17': {x: 320, y: 270},
    'ma-r-12-18': {x: 330, y: 270},
    'ma-r-12-19': {x: 340, y: 270},
    'ma-r-12-20': {x: 350, y: 270},
    'ma-r-12-21': {x: 360, y: 270},
    'ma-r-12-22': {x: 370, y: 270},
    'ma-r-12-23': {x: 380, y: 270},
    'ma-r-12-24': {x: 390, y: 270},



    //FOYER
    'f-l-1-1': {x: 230, y: 120},
    'f-l-1-2': {x: 240, y: 120},
    'f-l-1-3': {x: 250, y: 120},
    'f-l-1-4': {x: 260, y: 120},
    'f-l-1-5': {x: 270, y: 120},
    'f-r-1-6': {x: 280, y: 120},
    'f-r-1-7': {x: 290, y: 120},
    'f-r-1-8': {x: 300, y: 120},
    'f-r-1-9': {x: 310, y: 120},
    'f-r-1-10': {x: 320, y: 120},

    'f-l-2-1': {x: 230, y: 135},
    'f-l-2-2': {x: 240, y: 135},
    'f-l-2-3': {x: 250, y: 135},
    'f-l-2-4': {x: 260, y: 135},
    'f-l-2-5': {x: 270, y: 135},
    'f-r-2-6': {x: 280, y: 135},
    'f-r-2-7': {x: 290, y: 135},
    'f-r-2-8': {x: 300, y: 135},
    'f-r-2-9': {x: 310, y: 135},
    'f-r-2-10': {x: 320, y: 135},

    'f-l-3-1': {x: 230, y: 150},
    'f-l-3-2': {x: 240, y: 150},
    'f-l-3-3': {x: 250, y: 150},
    'f-l-3-4': {x: 260, y: 150},
    'f-l-3-5': {x: 270, y: 150},
    'f-r-3-6': {x: 280, y: 150},
    'f-r-3-7': {x: 290, y: 150},
    'f-r-3-8': {x: 300, y: 150},
    'f-r-3-9': {x: 310, y: 150},
    'f-r-3-10': {x: 320, y: 150},

    'f-l-4-1': {x: 230, y: 165},
    'f-l-4-2': {x: 240, y: 165},
    'f-l-4-3': {x: 250, y: 165},
    'f-l-4-4': {x: 260, y: 165},
    'f-l-4-5': {x: 270, y: 165},
    'f-r-4-6': {x: 280, y: 165},
    'f-r-4-7': {x: 290, y: 165},
    'f-r-4-8': {x: 300, y: 165},
    'f-r-4-9': {x: 310, y: 165},
    'f-r-4-10': {x: 320, y: 165},

    'f-l-5-1': {x: 230, y: 180},
    'f-l-5-2': {x: 240, y: 180},
    'f-l-5-3': {x: 250, y: 180},
    'f-l-5-4': {x: 260, y: 180},
    'f-l-5-5': {x: 270, y: 180},
    'f-r-5-6': {x: 280, y: 180},
    'f-r-5-7': {x: 290, y: 180},
    'f-r-5-8': {x: 300, y: 180},
    'f-r-5-9': {x: 310, y: 180},
    'f-r-5-10': {x: 320, y: 180},

    'f-l-6-1': {x: 230, y: 195},
    'f-l-6-2': {x: 240, y: 195},
    'f-l-6-3': {x: 250, y: 195},
    'f-l-6-4': {x: 260, y: 195},
    'f-l-6-5': {x: 270, y: 195},
    'f-r-6-6': {x: 280, y: 195},
    'f-r-6-7': {x: 290, y: 195},
    'f-r-6-8': {x: 300, y: 195},
    'f-r-6-9': {x: 310, y: 195},
    'f-r-6-10': {x: 320, y: 195},

    'f-l-7-1': {x: 230, y: 210},
    'f-l-7-2': {x: 240, y: 210},
    'f-l-7-3': {x: 250, y: 210},
    'f-l-7-4': {x: 260, y: 210},
    'f-l-7-5': {x: 270, y: 210},
    'f-r-7-6': {x: 280, y: 210},
    'f-r-7-7': {x: 290, y: 210},
    'f-r-7-8': {x: 300, y: 210},
    'f-r-7-9': {x: 310, y: 210},
    'f-r-7-10': {x: 320, y: 210},

    'f-l-8-1': {x: 230, y: 225},
    'f-l-8-2': {x: 240, y: 225},
    'f-l-8-3': {x: 250, y: 225},
    'f-l-8-4': {x: 260, y: 225},
    'f-l-8-5': {x: 270, y: 225},
    'f-r-8-6': {x: 280, y: 225},
    'f-r-8-7': {x: 290, y: 225},
    'f-r-8-8': {x: 300, y: 225},
    'f-r-8-9': {x: 310, y: 225},
    'f-r-8-10': {x: 320, y: 225},

    'f-l-9-1': {x: 230, y: 240},
    'f-l-9-2': {x: 240, y: 240},
    'f-l-9-3': {x: 250, y: 240},
    'f-l-9-4': {x: 260, y: 240},
    'f-l-9-5': {x: 270, y: 240},
    'f-r-9-6': {x: 280, y: 240},
    'f-r-9-7': {x: 290, y: 240},
    'f-r-9-8': {x: 300, y: 240},
    'f-r-9-9': {x: 310, y: 240},
    'f-r-9-10': {x: 320, y: 240},

    'f-l-10-1': {x: 230, y: 255},
    'f-l-10-2': {x: 240, y: 255},
    'f-l-10-3': {x: 250, y: 255},
    'f-l-10-4': {x: 260, y: 255},
    'f-l-10-5': {x: 270, y: 255},
    'f-r-10-6': {x: 280, y: 255},
    'f-r-10-7': {x: 290, y: 255},
    'f-r-10-8': {x: 300, y: 255},
    'f-r-10-9': {x: 310, y: 255},
    'f-r-10-10': {x: 320, y: 255},



    //FSK
    'fsk-l-1-1': {x: 230-55, y: 80+40},
    'fsk-l-1-2': {x: 240-55, y: 80+40},
    'fsk-l-1-3': {x: 250-55, y: 80+40},
    'fsk-l-1-4': {x: 260-55, y: 80+40},
    'fsk-l-1-5': {x: 270-55, y: 80+40},
    'fsk-l-1-6': {x: 280-55, y: 80+40},
    'fsk-l-1-7': {x: 290-55, y: 80+40},
    'fsk-l-1-8': {x: 300-55, y: 80+40},
    'fsk-l-1-9': {x: 310-55, y: 80+40},
    'fsk-l-1-10': {x: 320-55, y: 80+40},

    'fsk-r-1-11': {x: 330-55, y: 80+40},
    'fsk-r-1-12': {x: 340-55, y: 80+40},
    'fsk-r-1-13': {x: 350-55, y: 80+40},
    'fsk-r-1-14': {x: 360-55, y: 80+40},
    'fsk-r-1-15': {x: 370-55, y: 80+40},
    'fsk-r-1-16': {x: 380-55, y: 80+40},
    'fsk-r-1-17': {x: 390-55, y: 80+40},
    'fsk-r-1-18': {x: 400-55, y: 80+40},
    'fsk-r-1-19': {x: 410-55, y: 80+40},
    'fsk-r-1-20': {x: 420-55, y: 80+40},

    'fsk-l-2-1': {x: 230-55, y: 95+40},
    'fsk-l-2-2': {x: 240-55, y: 95+40},
    'fsk-l-2-3': {x: 250-55, y: 95+40},
    'fsk-l-2-4': {x: 260-55, y: 95+40},
    'fsk-l-2-5': {x: 270-55, y: 95+40},
    'fsk-l-2-6': {x: 280-55, y: 95+40},
    'fsk-l-2-7': {x: 290-55, y: 95+40},
    'fsk-l-2-8': {x: 300-55, y: 95+40},
    'fsk-l-2-9': {x: 310-55, y: 95+40},
    'fsk-l-2-10': {x: 320-55, y: 95+40},

    'fsk-r-2-11': {x: 330-55, y: 95+40},
    'fsk-r-2-12': {x: 340-55, y: 95+40},
    'fsk-r-2-13': {x: 350-55, y: 95+40},
    'fsk-r-2-14': {x: 360-55, y: 95+40},
    'fsk-r-2-15': {x: 370-55, y: 95+40},
    'fsk-r-2-16': {x: 380-55, y: 95+40},
    'fsk-r-2-17': {x: 390-55, y: 95+40},
    'fsk-r-2-18': {x: 400-55, y: 95+40},
    'fsk-r-2-19': {x: 410-55, y: 95+40},
    'fsk-r-2-20': {x: 420-55, y: 95+40},

    'fsk-l-3-1': {x: 230-55, y: 110+40},
    'fsk-l-3-2': {x: 240-55, y: 110+40},
    'fsk-l-3-3': {x: 250-55, y: 110+40},
    'fsk-l-3-4': {x: 260-55, y: 110+40},
    'fsk-l-3-5': {x: 270-55, y: 110+40},
    'fsk-l-3-6': {x: 280-55, y: 110+40},
    'fsk-l-3-7': {x: 290-55, y: 110+40},
    'fsk-l-3-8': {x: 300-55, y: 110+40},
    'fsk-l-3-9': {x: 310-55, y: 110+40},
    'fsk-l-3-10': {x: 320-55, y: 110+40},

    'fsk-r-3-11': {x: 330-55, y: 110+40},
    'fsk-r-3-12': {x: 340-55, y: 110+40},
    'fsk-r-3-13': {x: 350-55, y: 110+40},
    'fsk-r-3-14': {x: 360-55, y: 110+40},
    'fsk-r-3-15': {x: 370-55, y: 110+40},
    'fsk-r-3-16': {x: 380-55, y: 110+40},
    'fsk-r-3-17': {x: 390-55, y: 110+40},
    'fsk-r-3-18': {x: 400-55, y: 110+40},
    'fsk-r-3-19': {x: 410-55, y: 110+40},
    'fsk-r-3-20': {x: 420-55, y: 110+40},

    'fsk-l-4-1': {x: 230-55, y: 125+40},
    'fsk-l-4-2': {x: 240-55, y: 125+40},
    'fsk-l-4-3': {x: 250-55, y: 125+40},
    'fsk-l-4-4': {x: 260-55, y: 125+40},
    'fsk-l-4-5': {x: 270-55, y: 125+40},
    'fsk-l-4-6': {x: 280-55, y: 125+40},
    'fsk-l-4-7': {x: 290-55, y: 125+40},
    'fsk-l-4-8': {x: 300-55, y: 125+40},
    'fsk-l-4-9': {x: 310-55, y: 125+40},
    'fsk-l-4-10': {x: 320-55, y: 125+40},

    'fsk-r-4-11': {x: 330-55, y: 125+40},
    'fsk-r-4-12': {x: 340-55, y: 125+40},
    'fsk-r-4-13': {x: 350-55, y: 125+40},
    'fsk-r-4-14': {x: 360-55, y: 125+40},
    'fsk-r-4-15': {x: 370-55, y: 125+40},
    'fsk-r-4-16': {x: 380-55, y: 125+40},
    'fsk-r-4-17': {x: 390-55, y: 125+40},
    'fsk-r-4-18': {x: 400-55, y: 125+40},
    'fsk-r-4-19': {x: 410-55, y: 125+40},
    'fsk-r-4-20': {x: 420-55, y: 125+40},

    'fsk-l-5-1': {x: 230-55, y: 140+40},
    'fsk-l-5-2': {x: 240-55, y: 140+40},
    'fsk-l-5-3': {x: 250-55, y: 140+40},
    'fsk-l-5-4': {x: 260-55, y: 140+40},
    'fsk-l-5-5': {x: 270-55, y: 140+40},
    'fsk-l-5-6': {x: 280-55, y: 140+40},
    'fsk-l-5-7': {x: 290-55, y: 140+40},
    'fsk-l-5-8': {x: 300-55, y: 140+40},
    'fsk-l-5-9': {x: 310-55, y: 140+40},
    'fsk-l-5-10': {x: 320-55, y: 140+40},

    'fsk-r-5-11': {x: 330-55, y: 140+40},
    'fsk-r-5-12': {x: 340-55, y: 140+40},
    'fsk-r-5-13': {x: 350-55, y: 140+40},
    'fsk-r-5-14': {x: 360-55, y: 140+40},
    'fsk-r-5-15': {x: 370-55, y: 140+40},
    'fsk-r-5-16': {x: 380-55, y: 140+40},
    'fsk-r-5-17': {x: 390-55, y: 140+40},
    'fsk-r-5-18': {x: 400-55, y: 140+40},
    'fsk-r-5-19': {x: 410-55, y: 140+40},
    'fsk-r-5-20': {x: 420-55, y: 140+40},

    'fsk-l-6-1': {x: 230-55, y: 155+40},
    'fsk-l-6-2': {x: 240-55, y: 155+40},
    'fsk-l-6-3': {x: 250-55, y: 155+40},
    'fsk-l-6-4': {x: 260-55, y: 155+40},
    'fsk-l-6-5': {x: 270-55, y: 155+40},
    'fsk-l-6-6': {x: 280-55, y: 155+40},
    'fsk-l-6-7': {x: 290-55, y: 155+40},
    'fsk-l-6-8': {x: 300-55, y: 155+40},
    'fsk-l-6-9': {x: 310-55, y: 155+40},
    'fsk-l-6-10': {x: 320-55, y: 155+40},

    'fsk-r-6-11': {x: 330-55, y: 155+40},
    'fsk-r-6-12': {x: 340-55, y: 155+40},
    'fsk-r-6-13': {x: 350-55, y: 155+40},
    'fsk-r-6-14': {x: 360-55, y: 155+40},
    'fsk-r-6-15': {x: 370-55, y: 155+40},
    'fsk-r-6-16': {x: 380-55, y: 155+40},
    'fsk-r-6-17': {x: 390-55, y: 155+40},
    'fsk-r-6-18': {x: 400-55, y: 155+40},
    'fsk-r-6-19': {x: 410-55, y: 155+40},
    'fsk-r-6-20': {x: 420-55, y: 155+40},

    'fsk-l-7-1': {x: 230-55, y: 170+40},
    'fsk-l-7-2': {x: 240-55, y: 170+40},
    'fsk-l-7-3': {x: 250-55, y: 170+40},
    'fsk-l-7-4': {x: 260-55, y: 170+40},
    'fsk-l-7-5': {x: 270-55, y: 170+40},
    'fsk-l-7-6': {x: 280-55, y: 170+40},
    'fsk-l-7-7': {x: 290-55, y: 170+40},
    'fsk-l-7-8': {x: 300-55, y: 170+40},
    'fsk-l-7-9': {x: 310-55, y: 170+40},
    'fsk-l-7-10': {x: 320-55, y: 170+40},

    'fsk-r-7-11': {x: 330-55, y: 170+40},
    'fsk-r-7-12': {x: 340-55, y: 170+40},
    'fsk-r-7-13': {x: 350-55, y: 170+40},
    'fsk-r-7-14': {x: 360-55, y: 170+40},
    'fsk-r-7-15': {x: 370-55, y: 170+40},
    'fsk-r-7-16': {x: 380-55, y: 170+40},
    'fsk-r-7-17': {x: 390-55, y: 170+40},
    'fsk-r-7-18': {x: 400-55, y: 170+40},
    'fsk-r-7-19': {x: 410-55, y: 170+40},
    'fsk-r-7-20': {x: 420-55, y: 170+40},

    'fsk-l-8-1': {x: 230-55, y: 185+40},
    'fsk-l-8-2': {x: 240-55, y: 185+40},
    'fsk-l-8-3': {x: 250-55, y: 185+40},
    'fsk-l-8-4': {x: 260-55, y: 185+40},
    'fsk-l-8-5': {x: 270-55, y: 185+40},
    'fsk-l-8-6': {x: 280-55, y: 185+40},
    'fsk-l-8-7': {x: 290-55, y: 185+40},
    'fsk-l-8-8': {x: 300-55, y: 185+40},
    'fsk-l-8-9': {x: 310-55, y: 185+40},
    'fsk-l-8-10': {x: 320-55, y: 185+40},

    'fsk-r-8-11': {x: 330-55, y: 185+40},
    'fsk-r-8-12': {x: 340-55, y: 185+40},
    'fsk-r-8-13': {x: 350-55, y: 185+40},
    'fsk-r-8-14': {x: 360-55, y: 185+40},
    'fsk-r-8-15': {x: 370-55, y: 185+40},
    'fsk-r-8-16': {x: 380-55, y: 185+40},
    'fsk-r-8-17': {x: 390-55, y: 185+40},
    'fsk-r-8-18': {x: 400-55, y: 185+40},
    'fsk-r-8-19': {x: 410-55, y: 185+40},
    'fsk-r-8-20': {x: 420-55, y: 185+40},

    'fsk-l-9-1': {x: 230-55, y: 200+40},
    'fsk-l-9-2': {x: 240-55, y: 200+40},
    'fsk-l-9-3': {x: 250-55, y: 200+40},
    'fsk-l-9-4': {x: 260-55, y: 200+40},
    'fsk-l-9-5': {x: 270-55, y: 200+40},
    'fsk-l-9-6': {x: 280-55, y: 200+40},
    'fsk-l-9-7': {x: 290-55, y: 200+40},
    'fsk-l-9-8': {x: 300-55, y: 200+40},
    'fsk-l-9-9': {x: 310-55, y: 200+40},
    'fsk-l-9-10': {x: 320-55, y: 200+40},

    'fsk-r-9-11': {x: 330-55, y: 200+40},
    'fsk-r-9-12': {x: 340-55, y: 200+40},
    'fsk-r-9-13': {x: 350-55, y: 200+40},
    'fsk-r-9-14': {x: 360-55, y: 200+40},
    'fsk-r-9-15': {x: 370-55, y: 200+40},
    'fsk-r-9-16': {x: 380-55, y: 200+40},
    'fsk-r-9-17': {x: 390-55, y: 200+40},
    'fsk-r-9-18': {x: 400-55, y: 200+40},
    'fsk-r-9-19': {x: 410-55, y: 200+40},
    'fsk-r-9-20': {x: 420-55, y: 200+40},

    'fsk-l-10-1': {x: 230-55, y: 215+40},
    'fsk-l-10-2': {x: 240-55, y: 215+40},
    'fsk-l-10-3': {x: 250-55, y: 215+40},
    'fsk-l-10-4': {x: 260-55, y: 215+40},
    'fsk-l-10-5': {x: 270-55, y: 215+40},
    'fsk-l-10-6': {x: 280-55, y: 215+40},
    'fsk-l-10-7': {x: 290-55, y: 215+40},
    'fsk-l-10-8': {x: 300-55, y: 215+40},
    'fsk-l-10-9': {x: 310-55, y: 215+40},
    'fsk-l-10-10': {x: 320-55, y: 215+40},

    'fsk-r-10-11': {x: 330-55, y: 215+40},
    'fsk-r-10-12': {x: 340-55, y: 215+40},
    'fsk-r-10-13': {x: 350-55, y: 215+40},
    'fsk-r-10-14': {x: 360-55, y: 215+40},
    'fsk-r-10-15': {x: 370-55, y: 215+40},
    'fsk-r-10-16': {x: 380-55, y: 215+40},
    'fsk-r-10-17': {x: 390-55, y: 215+40},
    'fsk-r-10-18': {x: 400-55, y: 215+40},
    'fsk-r-10-19': {x: 410-55, y: 215+40},
    'fsk-r-10-20': {x: 420-55, y: 215+40},


    //TONSKI STUDIO
    'ts-l-1-1': {x: 230, y: 120},
    'ts-l-1-2': {x: 240, y: 120},
    'ts-l-1-3': {x: 250, y: 120},
    'ts-l-1-4': {x: 260, y: 120},
    'ts-l-1-5': {x: 270, y: 120},
    'ts-r-1-6': {x: 280, y: 120},
    'ts-r-1-7': {x: 290, y: 120},
    'ts-r-1-8': {x: 300, y: 120},
    'ts-r-1-9': {x: 310, y: 120},
    'ts-r-1-10': {x: 320, y: 120},

    'ts-l-2-1': {x: 230, y: 135},
    'ts-l-2-2': {x: 240, y: 135},
    'ts-l-2-3': {x: 250, y: 135},
    'ts-l-2-4': {x: 260, y: 135},
    'ts-l-2-5': {x: 270, y: 135},
    'ts-r-2-6': {x: 280, y: 135},
    'ts-r-2-7': {x: 290, y: 135},
    'ts-r-2-8': {x: 300, y: 135},
    'ts-r-2-9': {x: 310, y: 135},
    'ts-r-2-10': {x: 320, y: 135},

    'ts-l-3-1': {x: 230, y: 150},
    'ts-l-3-2': {x: 240, y: 150},
    'ts-l-3-3': {x: 250, y: 150},
    'ts-l-3-4': {x: 260, y: 150},
    'ts-l-3-5': {x: 270, y: 150},
    'ts-r-3-6': {x: 280, y: 150},
    'ts-r-3-7': {x: 290, y: 150},
    'ts-r-3-8': {x: 300, y: 150},
    'ts-r-3-9': {x: 310, y: 150},
    'ts-r-3-10': {x: 320, y: 150},

    'ts-l-4-1': {x: 230, y: 165},
    'ts-l-4-2': {x: 240, y: 165},
    'ts-l-4-3': {x: 250, y: 165},
    'ts-l-4-4': {x: 260, y: 165},
    'ts-l-4-5': {x: 270, y: 165},
    'ts-r-4-6': {x: 280, y: 165},
    'ts-r-4-7': {x: 290, y: 165},
    'ts-r-4-8': {x: 300, y: 165},
    'ts-r-4-9': {x: 310, y: 165},
    'ts-r-4-10': {x: 320, y: 165},

    'ts-l-5-1': {x: 230, y: 180},
    'ts-l-5-2': {x: 240, y: 180},
    'ts-l-5-3': {x: 250, y: 180},
    'ts-l-5-4': {x: 260, y: 180},
    'ts-l-5-5': {x: 270, y: 180},
    'ts-r-5-6': {x: 280, y: 180},
    'ts-r-5-7': {x: 290, y: 180},
    'ts-r-5-8': {x: 300, y: 180},
    'ts-r-5-9': {x: 310, y: 180},
    'ts-r-5-10': {x: 320, y: 180},

    //12x30
    'dt-l-1-1': {x: 110, y: 120},
    'dt-l-1-2': {x: 120, y: 120},
    'dt-l-1-3': {x: 130, y: 120},
    'dt-l-1-4': {x: 140, y: 120},
    'dt-l-1-5': {x: 150, y: 120},
    'dt-l-1-6': {x: 160, y: 120},
    'dt-l-1-7': {x: 170, y: 120},
    'dt-l-1-8': {x: 180, y: 120},
    'dt-l-1-9': {x: 190, y: 120},
    'dt-l-1-10': {x: 200, y: 120},
    'dt-l-1-11': {x: 210, y: 120},
    'dt-l-1-12': {x: 220, y: 120},
    'dt-l-1-13': {x: 230, y: 120},
    'dt-l-1-14': {x: 240, y: 120},
    'dt-l-1-15': {x: 250, y: 120},

    'dt-r-1-16': {x: 260, y: 120},
    'dt-r-1-17': {x: 270, y: 120},
    'dt-r-1-18': {x: 280, y: 120},
    'dt-r-1-19': {x: 290, y: 120},
    'dt-r-1-20': {x: 300, y: 120},
    'dt-r-1-21': {x: 310, y: 120},
    'dt-r-1-22': {x: 320, y: 120},
    'dt-r-1-23': {x: 330, y: 120},
    'dt-r-1-24': {x: 340, y: 120},
    'dt-r-1-25': {x: 350, y: 120},
    'dt-r-1-26': {x: 360, y: 120},
    'dt-r-1-27': {x: 370, y: 120},
    'dt-r-1-28': {x: 380, y: 120},
    'dt-r-1-29': {x: 390, y: 120},
    'dt-r-1-30': {x: 400, y: 120},

    'dt-l-2-1': {x: 105, y: 135},
    'dt-l-2-2': {x: 115, y: 135},
    'dt-l-2-3': {x: 125, y: 135},
    'dt-l-2-4': {x: 135, y: 135},
    'dt-l-2-5': {x: 145, y: 135},
    'dt-l-2-6': {x: 155, y: 135},
    'dt-l-2-7': {x: 165, y: 135},
    'dt-l-2-8': {x: 175, y: 135},
    'dt-l-2-9': {x: 185, y: 135},
    'dt-l-2-10': {x: 195, y: 135},
    'dt-l-2-11': {x: 205, y: 135},
    'dt-l-2-12': {x: 215, y: 135},
    'dt-l-2-13': {x: 225, y: 135},
    'dt-l-2-14': {x: 235, y: 135},
    'dt-l-2-15': {x: 245, y: 135},

    'dt-r-2-16': {x: 255, y: 135},
    'dt-r-2-17': {x: 265, y: 135},
    'dt-r-2-18': {x: 275, y: 135},
    'dt-r-2-19': {x: 285, y: 135},
    'dt-r-2-20': {x: 295, y: 135},
    'dt-r-2-21': {x: 305, y: 135},
    'dt-r-2-22': {x: 315, y: 135},
    'dt-r-2-23': {x: 325, y: 135},
    'dt-r-2-24': {x: 335, y: 135},
    'dt-r-2-25': {x: 345, y: 135},
    'dt-r-2-26': {x: 355, y: 135},
    'dt-r-2-27': {x: 365, y: 135},
    'dt-r-2-28': {x: 375, y: 135},
    'dt-r-2-29': {x: 385, y: 135},
    'dt-r-2-30': {x: 395, y: 135},

    'dt-l-3-1': {x: 100, y: 150},
    'dt-l-3-2': {x: 110, y: 150},
    'dt-l-3-3': {x: 120, y: 150},
    'dt-l-3-4': {x: 130, y: 150},
    'dt-l-3-5': {x: 140, y: 150},
    'dt-l-3-6': {x: 150, y: 150},
    'dt-l-3-7': {x: 160, y: 150},
    'dt-l-3-8': {x: 170, y: 150},
    'dt-l-3-9': {x: 180, y: 150},
    'dt-l-3-10': {x: 190, y: 150},
    'dt-l-3-11': {x: 200, y: 150},
    'dt-l-3-12': {x: 210, y: 150},
    'dt-l-3-13': {x: 220, y: 150},
    'dt-l-3-14': {x: 230, y: 150},
    'dt-l-3-15': {x: 240, y: 150},

    'dt-r-3-16': {x: 250, y: 150},
    'dt-r-3-17': {x: 260, y: 150},
    'dt-r-3-18': {x: 270, y: 150},
    'dt-r-3-19': {x: 280, y: 150},
    'dt-r-3-20': {x: 290, y: 150},
    'dt-r-3-21': {x: 300, y: 150},
    'dt-r-3-22': {x: 310, y: 150},
    'dt-r-3-23': {x: 320, y: 150},
    'dt-r-3-24': {x: 330, y: 150},
    'dt-r-3-25': {x: 340, y: 150},
    'dt-r-3-26': {x: 350, y: 150},
    'dt-r-3-27': {x: 360, y: 150},
    'dt-r-3-28': {x: 370, y: 150},
    'dt-r-3-29': {x: 380, y: 150},
    'dt-r-3-30': {x: 390, y: 150},

    'dt-l-4-1': {x: 105, y: 185},
    'dt-l-4-2': {x: 115, y: 185},
    'dt-l-4-3': {x: 125, y: 185},
    'dt-l-4-4': {x: 135, y: 185},
    'dt-l-4-5': {x: 145, y: 185},
    'dt-l-4-6': {x: 155, y: 185},
    'dt-l-4-7': {x: 165, y: 185},
    'dt-l-4-8': {x: 175, y: 185},
    'dt-l-4-9': {x: 185, y: 185},
    'dt-l-4-10': {x: 195, y: 185},
    'dt-l-4-11': {x: 205, y: 185},
    'dt-l-4-12': {x: 215, y: 185},
    'dt-l-4-13': {x: 225, y: 185},
    'dt-l-4-14': {x: 235, y: 185},
    'dt-l-4-15': {x: 245, y: 185},

    'dt-r-4-16': {x: 255, y: 185},
    'dt-r-4-17': {x: 265, y: 185},
    'dt-r-4-18': {x: 275, y: 185},
    'dt-r-4-19': {x: 285, y: 185},
    'dt-r-4-20': {x: 295, y: 185},
    'dt-r-4-21': {x: 305, y: 185},
    'dt-r-4-22': {x: 315, y: 185},
    'dt-r-4-23': {x: 325, y: 185},
    'dt-r-4-24': {x: 335, y: 185},
    'dt-r-4-25': {x: 345, y: 185},
    'dt-r-4-26': {x: 355, y: 185},
    'dt-r-4-27': {x: 365, y: 185},
    'dt-r-4-28': {x: 375, y: 185},
    'dt-r-4-29': {x: 385, y: 185},
    'dt-r-4-30': {x: 395, y: 185},

    'dt-l-5-1': {x: 100, y: 200},
    'dt-l-5-2': {x: 110, y: 200},
    'dt-l-5-3': {x: 120, y: 200},
    'dt-l-5-4': {x: 130, y: 200},
    'dt-l-5-5': {x: 140, y: 200},
    'dt-l-5-6': {x: 150, y: 200},
    'dt-l-5-7': {x: 160, y: 200},
    'dt-l-5-8': {x: 170, y: 200},
    'dt-l-5-9': {x: 180, y: 200},
    'dt-l-5-10': {x: 190, y: 200},
    'dt-l-5-11': {x: 200, y: 200},
    'dt-l-5-12': {x: 210, y: 200},
    'dt-l-5-13': {x: 220, y: 200},
    'dt-l-5-14': {x: 230, y: 200},
    'dt-l-5-15': {x: 240, y: 200},

    'dt-r-5-16': {x: 250, y: 200},
    'dt-r-5-17': {x: 260, y: 200},
    'dt-r-5-18': {x: 270, y: 200},
    'dt-r-5-19': {x: 280, y: 200},
    'dt-r-5-20': {x: 290, y: 200},
    'dt-r-5-21': {x: 300, y: 200},
    'dt-r-5-22': {x: 310, y: 200},
    'dt-r-5-23': {x: 320, y: 200},
    'dt-r-5-24': {x: 330, y: 200},
    'dt-r-5-25': {x: 340, y: 200},
    'dt-r-5-26': {x: 350, y: 200},
    'dt-r-5-27': {x: 360, y: 200},
    'dt-r-5-28': {x: 370, y: 200},
    'dt-r-5-29': {x: 380, y: 200},
    'dt-r-5-30': {x: 390, y: 200},

    'dt-l-6-1': {x: 105, y: 215},
    'dt-l-6-2': {x: 115, y: 215},
    'dt-l-6-3': {x: 125, y: 215},
    'dt-l-6-4': {x: 135, y: 215},
    'dt-l-6-5': {x: 145, y: 215},
    'dt-l-6-6': {x: 155, y: 215},
    'dt-l-6-7': {x: 165, y: 215},
    'dt-l-6-8': {x: 175, y: 215},
    'dt-l-6-9': {x: 185, y: 215},
    'dt-l-6-10': {x: 195, y: 215},
    'dt-l-6-11': {x: 205, y: 215},
    'dt-l-6-12': {x: 215, y: 215},
    'dt-l-6-13': {x: 225, y: 215},
    'dt-l-6-14': {x: 235, y: 215},
    'dt-l-6-15': {x: 245, y: 215},

    'dt-r-6-16': {x: 255, y: 215},
    'dt-r-6-17': {x: 265, y: 215},
    'dt-r-6-18': {x: 275, y: 215},
    'dt-r-6-19': {x: 285, y: 215},
    'dt-r-6-20': {x: 295, y: 215},
    'dt-r-6-21': {x: 305, y: 215},
    'dt-r-6-22': {x: 315, y: 215},
    'dt-r-6-23': {x: 325, y: 215},
    'dt-r-6-24': {x: 335, y: 215},
    'dt-r-6-25': {x: 345, y: 215},
    'dt-r-6-26': {x: 355, y: 215},
    'dt-r-6-27': {x: 365, y: 215},
    'dt-r-6-28': {x: 375, y: 215},
    'dt-r-6-29': {x: 385, y: 215},
    'dt-r-6-30': {x: 395, y: 215},

    'dt-l-7-1': {x: 100, y: 230},
    'dt-l-7-2': {x: 110, y: 230},
    'dt-l-7-3': {x: 120, y: 230},
    'dt-l-7-4': {x: 130, y: 230},
    'dt-l-7-5': {x: 140, y: 230},
    'dt-l-7-6': {x: 150, y: 230},
    'dt-l-7-7': {x: 160, y: 230},
    'dt-l-7-8': {x: 170, y: 230},
    'dt-l-7-9': {x: 180, y: 230},
    'dt-l-7-10': {x: 190, y: 230},
    'dt-l-7-11': {x: 200, y: 230},
    'dt-l-7-12': {x: 210, y: 230},
    'dt-l-7-13': {x: 220, y: 230},
    'dt-l-7-14': {x: 230, y: 230},
    'dt-l-7-15': {x: 240, y: 230},

    'dt-r-7-16': {x: 250, y: 230},
    'dt-r-7-17': {x: 260, y: 230},
    'dt-r-7-18': {x: 270, y: 230},
    'dt-r-7-19': {x: 280, y: 230},
    'dt-r-7-20': {x: 290, y: 230},
    'dt-r-7-21': {x: 300, y: 230},
    'dt-r-7-22': {x: 310, y: 230},
    'dt-r-7-23': {x: 320, y: 230},
    'dt-r-7-24': {x: 330, y: 230},
    'dt-r-7-25': {x: 340, y: 230},
    'dt-r-7-26': {x: 350, y: 230},
    'dt-r-7-27': {x: 360, y: 230},
    'dt-r-7-28': {x: 370, y: 230},
    'dt-r-7-29': {x: 380, y: 230},
    'dt-r-7-30': {x: 390, y: 230},

    'dt-l-8-1': {x: 105, y: 245},
    'dt-l-8-2': {x: 115, y: 245},
    'dt-l-8-3': {x: 125, y: 245},
    'dt-l-8-4': {x: 135, y: 245},
    'dt-l-8-5': {x: 145, y: 245},
    'dt-l-8-6': {x: 155, y: 245},
    'dt-l-8-7': {x: 165, y: 245},
    'dt-l-8-8': {x: 175, y: 245},
    'dt-l-8-9': {x: 185, y: 245},
    'dt-l-8-10': {x: 195, y: 245},
    'dt-l-8-11': {x: 205, y: 245},
    'dt-l-8-12': {x: 215, y: 245},
    'dt-l-8-13': {x: 225, y: 245},
    'dt-l-8-14': {x: 235, y: 245},
    'dt-l-8-15': {x: 245, y: 245},

    'dt-r-8-16': {x: 255, y: 245},
    'dt-r-8-17': {x: 265, y: 245},
    'dt-r-8-18': {x: 275, y: 245},
    'dt-r-8-19': {x: 285, y: 245},
    'dt-r-8-20': {x: 295, y: 245},
    'dt-r-8-21': {x: 305, y: 245},
    'dt-r-8-22': {x: 315, y: 245},
    'dt-r-8-23': {x: 325, y: 245},
    'dt-r-8-24': {x: 335, y: 245},
    'dt-r-8-25': {x: 345, y: 245},
    'dt-r-8-26': {x: 355, y: 245},
    'dt-r-8-27': {x: 365, y: 245},
    'dt-r-8-28': {x: 375, y: 245},
    'dt-r-8-29': {x: 385, y: 245},
    'dt-r-8-30': {x: 395, y: 245},

    'dt-l-9-1': {x: 100, y: 260},
    'dt-l-9-2': {x: 110, y: 260},
    'dt-l-9-3': {x: 120, y: 260},
    'dt-l-9-4': {x: 130, y: 260},
    'dt-l-9-5': {x: 140, y: 260},
    'dt-l-9-6': {x: 150, y: 260},
    'dt-l-9-7': {x: 160, y: 260},
    'dt-l-9-8': {x: 170, y: 260},
    'dt-l-9-9': {x: 180, y: 260},
    'dt-l-9-10': {x: 190, y: 260},
    'dt-l-9-11': {x: 200, y: 260},
    'dt-l-9-12': {x: 210, y: 260},
    'dt-l-9-13': {x: 220, y: 260},
    'dt-l-9-14': {x: 230, y: 260},
    'dt-l-9-15': {x: 240, y: 260},

    'dt-r-9-16': {x: 250, y: 260},
    'dt-r-9-17': {x: 260, y: 260},
    'dt-r-9-18': {x: 270, y: 260},
    'dt-r-9-19': {x: 280, y: 260},
    'dt-r-9-20': {x: 290, y: 260},
    'dt-r-9-21': {x: 300, y: 260},
    'dt-r-9-22': {x: 310, y: 260},
    'dt-r-9-23': {x: 320, y: 260},
    'dt-r-9-24': {x: 330, y: 260},
    'dt-r-9-25': {x: 340, y: 260},
    'dt-r-9-26': {x: 350, y: 260},
    'dt-r-9-27': {x: 360, y: 260},
    'dt-r-9-28': {x: 370, y: 260},
    'dt-r-9-29': {x: 380, y: 260},
    'dt-r-9-30': {x: 390, y: 260},

    'dt-l-10-1': {x: 105, y: 275},
    'dt-l-10-2': {x: 115, y: 275},
    'dt-l-10-3': {x: 125, y: 275},
    'dt-l-10-4': {x: 135, y: 275},
    'dt-l-10-5': {x: 145, y: 275},
    'dt-l-10-6': {x: 155, y: 275},
    'dt-l-10-7': {x: 165, y: 275},
    'dt-l-10-8': {x: 175, y: 275},
    'dt-l-10-9': {x: 185, y: 275},
    'dt-l-10-10': {x: 195, y: 275},
    'dt-l-10-11': {x: 205, y: 275},
    'dt-l-10-12': {x: 215, y: 275},
    'dt-l-10-13': {x: 225, y: 275},
    'dt-l-10-14': {x: 235, y: 275},
    'dt-l-10-15': {x: 245, y: 275},

    'dt-r-10-16': {x: 255, y: 275},
    'dt-r-10-17': {x: 265, y: 275},
    'dt-r-10-18': {x: 275, y: 275},
    'dt-r-10-19': {x: 285, y: 275},
    'dt-r-10-20': {x: 295, y: 275},
    'dt-r-10-21': {x: 305, y: 275},
    'dt-r-10-22': {x: 315, y: 275},
    'dt-r-10-23': {x: 325, y: 275},
    'dt-r-10-24': {x: 335, y: 275},
    'dt-r-10-25': {x: 345, y: 275},
    'dt-r-10-26': {x: 355, y: 275},
    'dt-r-10-27': {x: 365, y: 275},
    'dt-r-10-28': {x: 375, y: 275},
    'dt-r-10-29': {x: 385, y: 275},
    'dt-r-10-30': {x: 395, y: 275},

    'dt-l-11-1': {x: 100, y: 290},
    'dt-l-11-2': {x: 110, y: 290},
    'dt-l-11-3': {x: 120, y: 290},
    'dt-l-11-4': {x: 130, y: 290},
    'dt-l-11-5': {x: 140, y: 290},
    'dt-l-11-6': {x: 150, y: 290},
    'dt-l-11-7': {x: 160, y: 290},
    'dt-l-11-8': {x: 170, y: 290},
    'dt-l-11-9': {x: 180, y: 290},
    'dt-l-11-10': {x: 190, y: 290},
    'dt-l-11-11': {x: 200, y: 290},
    'dt-l-11-12': {x: 210, y: 290},
    'dt-l-11-13': {x: 220, y: 290},
    'dt-l-11-14': {x: 230, y: 290},
    'dt-l-11-15': {x: 240, y: 290},

    'dt-r-11-16': {x: 250, y: 290},
    'dt-r-11-17': {x: 260, y: 290},
    'dt-r-11-18': {x: 270, y: 290},
    'dt-r-11-19': {x: 280, y: 290},
    'dt-r-11-20': {x: 290, y: 290},
    'dt-r-11-21': {x: 300, y: 290},
    'dt-r-11-22': {x: 310, y: 290},
    'dt-r-11-23': {x: 320, y: 290},
    'dt-r-11-24': {x: 330, y: 290},
    'dt-r-11-25': {x: 340, y: 290},
    'dt-r-11-26': {x: 350, y: 290},
    'dt-r-11-27': {x: 360, y: 290},
    'dt-r-11-28': {x: 370, y: 290},
    'dt-r-11-29': {x: 380, y: 290},
    'dt-r-11-30': {x: 390, y: 290},

    'dt-l-12-1': {x: 100, y: 305},
    'dt-l-12-2': {x: 110, y: 305},
    'dt-l-12-3': {x: 120, y: 305},
    'dt-l-12-4': {x: 130, y: 305},
    'dt-l-12-5': {x: 140, y: 305},
    'dt-l-12-6': {x: 150, y: 305},
    'dt-l-12-7': {x: 160, y: 305},
    'dt-l-12-8': {x: 170, y: 305},
    'dt-l-12-9': {x: 180, y: 305},
    'dt-l-12-10': {x: 190, y: 305},
    'dt-l-12-11': {x: 200, y: 305},
    'dt-l-12-12': {x: 210, y: 305},
    'dt-l-12-13': {x: 220, y: 305},
    'dt-l-12-14': {x: 230, y: 305},
    'dt-l-12-15': {x: 240, y: 305},

    'dt-r-12-16': {x: 250, y: 305},
    'dt-r-12-17': {x: 260, y: 305},
    'dt-r-12-18': {x: 270, y: 305},
    'dt-r-12-19': {x: 280, y: 305},
    'dt-r-12-20': {x: 290, y: 305},
    'dt-r-12-21': {x: 300, y: 305},
    'dt-r-12-22': {x: 310, y: 305},
    'dt-r-12-23': {x: 320, y: 305},
    'dt-r-12-24': {x: 330, y: 305},
    'dt-r-12-25': {x: 340, y: 305},
    'dt-r-12-26': {x: 350, y: 305},
    'dt-r-12-27': {x: 360, y: 305},
    'dt-r-12-28': {x: 370, y: 305},
    'dt-r-12-29': {x: 380, y: 305},
    'dt-r-12-30': {x: 390, y: 305},

    'dt-l-13-1': {x: 100, y: 320},
    'dt-l-13-2': {x: 110, y: 320},
    'dt-l-13-3': {x: 120, y: 320},
    'dt-l-13-4': {x: 130, y: 320},
    'dt-l-13-5': {x: 140, y: 320},
    'dt-l-13-6': {x: 150, y: 320},
    'dt-l-13-7': {x: 160, y: 320},
    'dt-l-13-8': {x: 170, y: 320},
    'dt-l-13-9': {x: 180, y: 320},
    'dt-l-13-10': {x: 190, y: 320},
    'dt-l-13-11': {x: 200, y: 320},
    'dt-l-13-12': {x: 210, y: 320},
    'dt-l-13-13': {x: 220, y: 320},
    'dt-l-13-14': {x: 230, y: 320},
    'dt-l-13-15': {x: 240, y: 320},

    'dt-r-13-16': {x: 250, y: 320},
    'dt-r-13-17': {x: 260, y: 320},
    'dt-r-13-18': {x: 270, y: 320},
    'dt-r-13-19': {x: 280, y: 320},
    'dt-r-13-20': {x: 290, y: 320},
    'dt-r-13-21': {x: 300, y: 320},
    'dt-r-13-22': {x: 310, y: 320},
    'dt-r-13-23': {x: 320, y: 320},
    'dt-r-13-24': {x: 330, y: 320},
    'dt-r-13-25': {x: 340, y: 320},
    'dt-r-13-26': {x: 350, y: 320},
    'dt-r-13-27': {x: 360, y: 320},
    'dt-r-13-28': {x: 370, y: 320},
    'dt-r-13-29': {x: 380, y: 320},
    'dt-r-13-30': {x: 390, y: 320},

    'dt-l-14-1': {x: 100, y: 335},
    'dt-l-14-2': {x: 110, y: 335},
    'dt-l-14-3': {x: 120, y: 335},
    'dt-l-14-4': {x: 130, y: 335},
    'dt-l-14-5': {x: 140, y: 335},
    'dt-l-14-6': {x: 150, y: 335},
    'dt-l-14-7': {x: 160, y: 335},
    'dt-l-14-8': {x: 170, y: 335},
    'dt-l-14-9': {x: 180, y: 335},
    'dt-l-14-10': {x: 190, y: 335},
    'dt-l-14-11': {x: 200, y: 335},
    'dt-l-14-12': {x: 210, y: 335},
    'dt-l-14-13': {x: 220, y: 335},
    'dt-l-14-14': {x: 230, y: 335},
    'dt-l-14-15': {x: 240, y: 335},

    'dt-r-14-16': {x: 250, y: 335},
    'dt-r-14-17': {x: 260, y: 335},
    'dt-r-14-18': {x: 270, y: 335},
    'dt-r-14-19': {x: 280, y: 335},
    'dt-r-14-20': {x: 290, y: 335},
    'dt-r-14-21': {x: 300, y: 335},
    'dt-r-14-22': {x: 310, y: 335},
    'dt-r-14-23': {x: 320, y: 335},
    'dt-r-14-24': {x: 330, y: 335},
    'dt-r-14-25': {x: 340, y: 335},
    'dt-r-14-26': {x: 350, y: 335},
    'dt-r-14-27': {x: 360, y: 335},
    'dt-r-14-28': {x: 370, y: 335},
    'dt-r-14-29': {x: 380, y: 335},
    'dt-r-14-30': {x: 390, y: 335},

    'dt-l-15-1': {x: 100, y: 350},
    'dt-l-15-2': {x: 110, y: 350},
    'dt-l-15-3': {x: 120, y: 350},
    'dt-l-15-4': {x: 130, y: 350},
    'dt-l-15-5': {x: 140, y: 350},
    'dt-l-15-6': {x: 150, y: 350},
    'dt-l-15-7': {x: 160, y: 350},
    'dt-l-15-8': {x: 170, y: 350},
    'dt-l-15-9': {x: 180, y: 350},
    'dt-l-15-10': {x: 190, y: 350},
    'dt-l-15-11': {x: 200, y: 350},
    'dt-l-15-12': {x: 210, y: 350},
    'dt-l-15-13': {x: 220, y: 350},
    'dt-l-15-14': {x: 230, y: 350},
    'dt-l-15-15': {x: 240, y: 350},

    'dt-r-15-16': {x: 250, y: 350},
    'dt-r-15-17': {x: 260, y: 350},
    'dt-r-15-18': {x: 270, y: 350},
    'dt-r-15-19': {x: 280, y: 350},
    'dt-r-15-20': {x: 290, y: 350},
    'dt-r-15-21': {x: 300, y: 350},
    'dt-r-15-22': {x: 310, y: 350},
    'dt-r-15-23': {x: 320, y: 350},
    'dt-r-15-24': {x: 330, y: 350},
    'dt-r-15-25': {x: 340, y: 350},
    'dt-r-15-26': {x: 350, y: 350},
    'dt-r-15-27': {x: 360, y: 350},
    'dt-r-15-28': {x: 370, y: 350},
    'dt-r-15-29': {x: 380, y: 350},
    'dt-r-15-30': {x: 390, y: 350},


    //GOSTOVANJA 500
    'g500-l-1-1': {x: 30, y: 105},
    'g500-l-1-2': {x: 40, y: 105},
    'g500-l-1-3': {x: 50, y: 105},
    'g500-l-1-4': {x: 60, y: 105},
    'g500-l-1-5': {x: 70, y: 105},
    'g500-l-1-6': {x: 80, y: 105},
    'g500-l-1-7': {x: 90, y: 105},
    'g500-l-1-8': {x: 100, y: 105},
    'g500-l-1-9': {x: 110, y: 105},
    'g500-l-1-10': {x: 120, y: 105},
    'g500-l-1-11': {x: 130, y: 105},
    'g500-l-1-12': {x: 140, y: 105},
    'g500-l-1-13': {x: 150, y: 105},
    'g500-l-1-14': {x: 160, y: 105},
    'g500-l-1-15': {x: 170, y: 105},
    'g500-l-1-16': {x: 180, y: 105},
    'g500-l-1-17': {x: 190, y: 105},
    'g500-l-1-18': {x: 200, y: 105},
    'g500-l-1-19': {x: 210, y: 105},
    'g500-l-1-20': {x: 220, y: 105},
    'g500-l-1-21': {x: 230, y: 105},
    'g500-l-1-22': {x: 240, y: 105},
    'g500-l-1-23': {x: 250, y: 105},
    'g500-l-1-24': {x: 260, y: 105},
    'g500-l-1-25': {x: 270, y: 105},
    'g500-r-1-26': {x: 280, y: 105},
    'g500-r-1-27': {x: 290, y: 105},
    'g500-r-1-28': {x: 300, y: 105},
    'g500-r-1-29': {x: 310, y: 105},
    'g500-r-1-30': {x: 320, y: 105},
    'g500-r-1-31': {x: 330, y: 105},
    'g500-r-1-32': {x: 340, y: 105},
    'g500-r-1-33': {x: 350, y: 105},
    'g500-r-1-34': {x: 360, y: 105},
    'g500-r-1-35': {x: 370, y: 105},
    'g500-r-1-36': {x: 380, y: 105},
    'g500-r-1-37': {x: 390, y: 105},
    'g500-r-1-38': {x: 400, y: 105},
    'g500-r-1-39': {x: 410, y: 105},
    'g500-r-1-40': {x: 420, y: 105},
    'g500-r-1-41': {x: 430, y: 105},
    'g500-r-1-42': {x: 440, y: 105},
    'g500-r-1-43': {x: 450, y: 105},
    'g500-r-1-44': {x: 460, y: 105},
    'g500-r-1-45': {x: 470, y: 105},
    'g500-r-1-46': {x: 480, y: 105},
    'g500-r-1-47': {x: 490, y: 105},
    'g500-r-1-48': {x: 500, y: 105},
    'g500-r-1-49': {x: 510, y: 105},
    'g500-r-1-50': {x: 520, y: 105},

    'g500-l-2-1': {x: 30, y: 120},
    'g500-l-2-2': {x: 40, y: 120},
    'g500-l-2-3': {x: 50, y: 120},
    'g500-l-2-4': {x: 60, y: 120},
    'g500-l-2-5': {x: 70, y: 120},
    'g500-l-2-6': {x: 80, y: 120},
    'g500-l-2-7': {x: 90, y: 120},
    'g500-l-2-8': {x: 100, y: 120},
    'g500-l-2-9': {x: 110, y: 120},
    'g500-l-2-10': {x: 120, y: 120},
    'g500-l-2-11': {x: 130, y: 120},
    'g500-l-2-12': {x: 140, y: 120},
    'g500-l-2-13': {x: 150, y: 120},
    'g500-l-2-14': {x: 160, y: 120},
    'g500-l-2-15': {x: 170, y: 120},
    'g500-l-2-16': {x: 180, y: 120},
    'g500-l-2-17': {x: 190, y: 120},
    'g500-l-2-18': {x: 200, y: 120},
    'g500-l-2-19': {x: 210, y: 120},
    'g500-l-2-20': {x: 220, y: 120},
    'g500-l-2-21': {x: 230, y: 120},
    'g500-l-2-22': {x: 240, y: 120},
    'g500-l-2-23': {x: 250, y: 120},
    'g500-l-2-24': {x: 260, y: 120},
    'g500-l-2-25': {x: 270, y: 120},
    'g500-r-2-26': {x: 280, y: 120},
    'g500-r-2-27': {x: 290, y: 120},
    'g500-r-2-28': {x: 300, y: 120},
    'g500-r-2-29': {x: 310, y: 120},
    'g500-r-2-30': {x: 320, y: 120},
    'g500-r-2-31': {x: 330, y: 120},
    'g500-r-2-32': {x: 340, y: 120},
    'g500-r-2-33': {x: 350, y: 120},
    'g500-r-2-34': {x: 360, y: 120},
    'g500-r-2-35': {x: 370, y: 120},
    'g500-r-2-36': {x: 380, y: 120},
    'g500-r-2-37': {x: 390, y: 120},
    'g500-r-2-38': {x: 400, y: 120},
    'g500-r-2-39': {x: 410, y: 120},
    'g500-r-2-40': {x: 420, y: 120},
    'g500-r-2-41': {x: 430, y: 120},
    'g500-r-2-42': {x: 440, y: 120},
    'g500-r-2-43': {x: 450, y: 120},
    'g500-r-2-44': {x: 460, y: 120},
    'g500-r-2-45': {x: 470, y: 120},
    'g500-r-2-46': {x: 480, y: 120},
    'g500-r-2-47': {x: 490, y: 120},
    'g500-r-2-48': {x: 500, y: 120},
    'g500-r-2-49': {x: 510, y: 120},
    'g500-r-2-50': {x: 520, y: 120},

    'g500-l-3-1': {x: 30, y: 135},
    'g500-l-3-2': {x: 40, y: 135},
    'g500-l-3-3': {x: 50, y: 135},
    'g500-l-3-4': {x: 60, y: 135},
    'g500-l-3-5': {x: 70, y: 135},
    'g500-l-3-6': {x: 80, y: 135},
    'g500-l-3-7': {x: 90, y: 135},
    'g500-l-3-8': {x: 100, y: 135},
    'g500-l-3-9': {x: 110, y: 135},
    'g500-l-3-10': {x: 120, y: 135},
    'g500-l-3-11': {x: 130, y: 135},
    'g500-l-3-12': {x: 140, y: 135},
    'g500-l-3-13': {x: 150, y: 135},
    'g500-l-3-14': {x: 160, y: 135},
    'g500-l-3-15': {x: 170, y: 135},
    'g500-l-3-16': {x: 180, y: 135},
    'g500-l-3-17': {x: 190, y: 135},
    'g500-l-3-18': {x: 200, y: 135},
    'g500-l-3-19': {x: 210, y: 135},
    'g500-l-3-20': {x: 220, y: 135},
    'g500-l-3-21': {x: 230, y: 135},
    'g500-l-3-22': {x: 240, y: 135},
    'g500-l-3-23': {x: 250, y: 135},
    'g500-l-3-24': {x: 260, y: 135},
    'g500-l-3-25': {x: 270, y: 135},
    'g500-r-3-26': {x: 280, y: 135},
    'g500-r-3-27': {x: 290, y: 135},
    'g500-r-3-28': {x: 300, y: 135},
    'g500-r-3-29': {x: 310, y: 135},
    'g500-r-3-30': {x: 320, y: 135},
    'g500-r-3-31': {x: 330, y: 135},
    'g500-r-3-32': {x: 340, y: 135},
    'g500-r-3-33': {x: 350, y: 135},
    'g500-r-3-34': {x: 360, y: 135},
    'g500-r-3-35': {x: 370, y: 135},
    'g500-r-3-36': {x: 380, y: 135},
    'g500-r-3-37': {x: 390, y: 135},
    'g500-r-3-38': {x: 400, y: 135},
    'g500-r-3-39': {x: 410, y: 135},
    'g500-r-3-40': {x: 420, y: 135},
    'g500-r-3-41': {x: 430, y: 135},
    'g500-r-3-42': {x: 440, y: 135},
    'g500-r-3-43': {x: 450, y: 135},
    'g500-r-3-44': {x: 460, y: 135},
    'g500-r-3-45': {x: 470, y: 135},
    'g500-r-3-46': {x: 480, y: 135},
    'g500-r-3-47': {x: 490, y: 135},
    'g500-r-3-48': {x: 500, y: 135},
    'g500-r-3-49': {x: 510, y: 135},
    'g500-r-3-50': {x: 520, y: 135},

    'g500-l-4-1': {x: 30, y: 150},
    'g500-l-4-2': {x: 40, y: 150},
    'g500-l-4-3': {x: 50, y: 150},
    'g500-l-4-4': {x: 60, y: 150},
    'g500-l-4-5': {x: 70, y: 150},
    'g500-l-4-6': {x: 80, y: 150},
    'g500-l-4-7': {x: 90, y: 150},
    'g500-l-4-8': {x: 100, y: 150},
    'g500-l-4-9': {x: 110, y: 150},
    'g500-l-4-10': {x: 120, y: 150},
    'g500-l-4-11': {x: 130, y: 150},
    'g500-l-4-12': {x: 140, y: 150},
    'g500-l-4-13': {x: 150, y: 150},
    'g500-l-4-14': {x: 160, y: 150},
    'g500-l-4-15': {x: 170, y: 150},
    'g500-l-4-16': {x: 180, y: 150},
    'g500-l-4-17': {x: 190, y: 150},
    'g500-l-4-18': {x: 200, y: 150},
    'g500-l-4-19': {x: 210, y: 150},
    'g500-l-4-20': {x: 220, y: 150},
    'g500-l-4-21': {x: 230, y: 150},
    'g500-l-4-22': {x: 240, y: 150},
    'g500-l-4-23': {x: 250, y: 150},
    'g500-l-4-24': {x: 260, y: 150},
    'g500-l-4-25': {x: 270, y: 150},
    'g500-r-4-26': {x: 280, y: 150},
    'g500-r-4-27': {x: 290, y: 150},
    'g500-r-4-28': {x: 300, y: 150},
    'g500-r-4-29': {x: 310, y: 150},
    'g500-r-4-30': {x: 320, y: 150},
    'g500-r-4-31': {x: 330, y: 150},
    'g500-r-4-32': {x: 340, y: 150},
    'g500-r-4-33': {x: 350, y: 150},
    'g500-r-4-34': {x: 360, y: 150},
    'g500-r-4-35': {x: 370, y: 150},
    'g500-r-4-36': {x: 380, y: 150},
    'g500-r-4-37': {x: 390, y: 150},
    'g500-r-4-38': {x: 400, y: 150},
    'g500-r-4-39': {x: 410, y: 150},
    'g500-r-4-40': {x: 420, y: 150},
    'g500-r-4-41': {x: 430, y: 150},
    'g500-r-4-42': {x: 440, y: 150},
    'g500-r-4-43': {x: 450, y: 150},
    'g500-r-4-44': {x: 460, y: 150},
    'g500-r-4-45': {x: 470, y: 150},
    'g500-r-4-46': {x: 480, y: 150},
    'g500-r-4-47': {x: 490, y: 150},
    'g500-r-4-48': {x: 500, y: 150},
    'g500-r-4-49': {x: 510, y: 150},
    'g500-r-4-50': {x: 520, y: 150},

    'g500-l-5-1': {x: 30, y: 165},
    'g500-l-5-2': {x: 40, y: 165},
    'g500-l-5-3': {x: 50, y: 165},
    'g500-l-5-4': {x: 60, y: 165},
    'g500-l-5-5': {x: 70, y: 165},
    'g500-l-5-6': {x: 80, y: 165},
    'g500-l-5-7': {x: 90, y: 165},
    'g500-l-5-8': {x: 100, y: 165},
    'g500-l-5-9': {x: 110, y: 165},
    'g500-l-5-10': {x: 120, y: 165},
    'g500-l-5-11': {x: 130, y: 165},
    'g500-l-5-12': {x: 140, y: 165},
    'g500-l-5-13': {x: 150, y: 165},
    'g500-l-5-14': {x: 160, y: 165},
    'g500-l-5-15': {x: 170, y: 165},
    'g500-l-5-16': {x: 180, y: 165},
    'g500-l-5-17': {x: 190, y: 165},
    'g500-l-5-18': {x: 200, y: 165},
    'g500-l-5-19': {x: 210, y: 165},
    'g500-l-5-20': {x: 220, y: 165},
    'g500-l-5-21': {x: 230, y: 165},
    'g500-l-5-22': {x: 240, y: 165},
    'g500-l-5-23': {x: 250, y: 165},
    'g500-l-5-24': {x: 260, y: 165},
    'g500-l-5-25': {x: 270, y: 165},
    'g500-r-5-26': {x: 280, y: 165},
    'g500-r-5-27': {x: 290, y: 165},
    'g500-r-5-28': {x: 300, y: 165},
    'g500-r-5-29': {x: 310, y: 165},
    'g500-r-5-30': {x: 320, y: 165},
    'g500-r-5-31': {x: 330, y: 165},
    'g500-r-5-32': {x: 340, y: 165},
    'g500-r-5-33': {x: 350, y: 165},
    'g500-r-5-34': {x: 360, y: 165},
    'g500-r-5-35': {x: 370, y: 165},
    'g500-r-5-36': {x: 380, y: 165},
    'g500-r-5-37': {x: 390, y: 165},
    'g500-r-5-38': {x: 400, y: 165},
    'g500-r-5-39': {x: 410, y: 165},
    'g500-r-5-40': {x: 420, y: 165},
    'g500-r-5-41': {x: 430, y: 165},
    'g500-r-5-42': {x: 440, y: 165},
    'g500-r-5-43': {x: 450, y: 165},
    'g500-r-5-44': {x: 460, y: 165},
    'g500-r-5-45': {x: 470, y: 165},
    'g500-r-5-46': {x: 480, y: 165},
    'g500-r-5-47': {x: 490, y: 165},
    'g500-r-5-48': {x: 500, y: 165},
    'g500-r-5-49': {x: 510, y: 165},
    'g500-r-5-50': {x: 520, y: 165},

    'g500-l-6-1': {x: 30, y: 180},
    'g500-l-6-2': {x: 40, y: 180},
    'g500-l-6-3': {x: 50, y: 180},
    'g500-l-6-4': {x: 60, y: 180},
    'g500-l-6-5': {x: 70, y: 180},
    'g500-l-6-6': {x: 80, y: 180},
    'g500-l-6-7': {x: 90, y: 180},
    'g500-l-6-8': {x: 100, y: 180},
    'g500-l-6-9': {x: 110, y: 180},
    'g500-l-6-10': {x: 120, y: 180},
    'g500-l-6-11': {x: 130, y: 180},
    'g500-l-6-12': {x: 140, y: 180},
    'g500-l-6-13': {x: 150, y: 180},
    'g500-l-6-14': {x: 160, y: 180},
    'g500-l-6-15': {x: 170, y: 180},
    'g500-l-6-16': {x: 180, y: 180},
    'g500-l-6-17': {x: 190, y: 180},
    'g500-l-6-18': {x: 200, y: 180},
    'g500-l-6-19': {x: 210, y: 180},
    'g500-l-6-20': {x: 220, y: 180},
    'g500-l-6-21': {x: 230, y: 180},
    'g500-l-6-22': {x: 240, y: 180},
    'g500-l-6-23': {x: 250, y: 180},
    'g500-l-6-24': {x: 260, y: 180},
    'g500-l-6-25': {x: 270, y: 180},
    'g500-r-6-26': {x: 280, y: 180},
    'g500-r-6-27': {x: 290, y: 180},
    'g500-r-6-28': {x: 300, y: 180},
    'g500-r-6-29': {x: 310, y: 180},
    'g500-r-6-30': {x: 320, y: 180},
    'g500-r-6-31': {x: 330, y: 180},
    'g500-r-6-32': {x: 340, y: 180},
    'g500-r-6-33': {x: 350, y: 180},
    'g500-r-6-34': {x: 360, y: 180},
    'g500-r-6-35': {x: 370, y: 180},
    'g500-r-6-36': {x: 380, y: 180},
    'g500-r-6-37': {x: 390, y: 180},
    'g500-r-6-38': {x: 400, y: 180},
    'g500-r-6-39': {x: 410, y: 180},
    'g500-r-6-40': {x: 420, y: 180},
    'g500-r-6-41': {x: 430, y: 180},
    'g500-r-6-42': {x: 440, y: 180},
    'g500-r-6-43': {x: 450, y: 180},
    'g500-r-6-44': {x: 460, y: 180},
    'g500-r-6-45': {x: 470, y: 180},
    'g500-r-6-46': {x: 480, y: 180},
    'g500-r-6-47': {x: 490, y: 180},
    'g500-r-6-48': {x: 500, y: 180},
    'g500-r-6-49': {x: 510, y: 180},
    'g500-r-6-50': {x: 520, y: 180},

    'g500-l-7-1': {x: 30, y: 195},
    'g500-l-7-2': {x: 40, y: 195},
    'g500-l-7-3': {x: 50, y: 195},
    'g500-l-7-4': {x: 60, y: 195},
    'g500-l-7-5': {x: 70, y: 195},
    'g500-l-7-6': {x: 80, y: 195},
    'g500-l-7-7': {x: 90, y: 195},
    'g500-l-7-8': {x: 100, y: 195},
    'g500-l-7-9': {x: 110, y: 195},
    'g500-l-7-10': {x: 120, y: 195},
    'g500-l-7-11': {x: 130, y: 195},
    'g500-l-7-12': {x: 140, y: 195},
    'g500-l-7-13': {x: 150, y: 195},
    'g500-l-7-14': {x: 160, y: 195},
    'g500-l-7-15': {x: 170, y: 195},
    'g500-l-7-16': {x: 180, y: 195},
    'g500-l-7-17': {x: 190, y: 195},
    'g500-l-7-18': {x: 200, y: 195},
    'g500-l-7-19': {x: 210, y: 195},
    'g500-l-7-20': {x: 220, y: 195},
    'g500-l-7-21': {x: 230, y: 195},
    'g500-l-7-22': {x: 240, y: 195},
    'g500-l-7-23': {x: 250, y: 195},
    'g500-l-7-24': {x: 260, y: 195},
    'g500-l-7-25': {x: 270, y: 195},
    'g500-r-7-26': {x: 280, y: 195},
    'g500-r-7-27': {x: 290, y: 195},
    'g500-r-7-28': {x: 300, y: 195},
    'g500-r-7-29': {x: 310, y: 195},
    'g500-r-7-30': {x: 320, y: 195},
    'g500-r-7-31': {x: 330, y: 195},
    'g500-r-7-32': {x: 340, y: 195},
    'g500-r-7-33': {x: 350, y: 195},
    'g500-r-7-34': {x: 360, y: 195},
    'g500-r-7-35': {x: 370, y: 195},
    'g500-r-7-36': {x: 380, y: 195},
    'g500-r-7-37': {x: 390, y: 195},
    'g500-r-7-38': {x: 400, y: 195},
    'g500-r-7-39': {x: 410, y: 195},
    'g500-r-7-40': {x: 420, y: 195},
    'g500-r-7-41': {x: 430, y: 195},
    'g500-r-7-42': {x: 440, y: 195},
    'g500-r-7-43': {x: 450, y: 195},
    'g500-r-7-44': {x: 460, y: 195},
    'g500-r-7-45': {x: 470, y: 195},
    'g500-r-7-46': {x: 480, y: 195},
    'g500-r-7-47': {x: 490, y: 195},
    'g500-r-7-48': {x: 500, y: 195},
    'g500-r-7-49': {x: 510, y: 195},
    'g500-r-7-50': {x: 520, y: 195},

    'g500-l-8-1': {x: 30, y: 210},
    'g500-l-8-2': {x: 40, y: 210},
    'g500-l-8-3': {x: 50, y: 210},
    'g500-l-8-4': {x: 60, y: 210},
    'g500-l-8-5': {x: 70, y: 210},
    'g500-l-8-6': {x: 80, y: 210},
    'g500-l-8-7': {x: 90, y: 210},
    'g500-l-8-8': {x: 100, y: 210},
    'g500-l-8-9': {x: 110, y: 210},
    'g500-l-8-10': {x: 120, y: 210},
    'g500-l-8-11': {x: 130, y: 210},
    'g500-l-8-12': {x: 140, y: 210},
    'g500-l-8-13': {x: 150, y: 210},
    'g500-l-8-14': {x: 160, y: 210},
    'g500-l-8-15': {x: 170, y: 210},
    'g500-l-8-16': {x: 180, y: 210},
    'g500-l-8-17': {x: 190, y: 210},
    'g500-l-8-18': {x: 200, y: 210},
    'g500-l-8-19': {x: 210, y: 210},
    'g500-l-8-20': {x: 220, y: 210},
    'g500-l-8-21': {x: 230, y: 210},
    'g500-l-8-22': {x: 240, y: 210},
    'g500-l-8-23': {x: 250, y: 210},
    'g500-l-8-24': {x: 260, y: 210},
    'g500-l-8-25': {x: 270, y: 210},
    'g500-r-8-26': {x: 280, y: 210},
    'g500-r-8-27': {x: 290, y: 210},
    'g500-r-8-28': {x: 300, y: 210},
    'g500-r-8-29': {x: 310, y: 210},
    'g500-r-8-30': {x: 320, y: 210},
    'g500-r-8-31': {x: 330, y: 210},
    'g500-r-8-32': {x: 340, y: 210},
    'g500-r-8-33': {x: 350, y: 210},
    'g500-r-8-34': {x: 360, y: 210},
    'g500-r-8-35': {x: 370, y: 210},
    'g500-r-8-36': {x: 380, y: 210},
    'g500-r-8-37': {x: 390, y: 210},
    'g500-r-8-38': {x: 400, y: 210},
    'g500-r-8-39': {x: 410, y: 210},
    'g500-r-8-40': {x: 420, y: 210},
    'g500-r-8-41': {x: 430, y: 210},
    'g500-r-8-42': {x: 440, y: 210},
    'g500-r-8-43': {x: 450, y: 210},
    'g500-r-8-44': {x: 460, y: 210},
    'g500-r-8-45': {x: 470, y: 210},
    'g500-r-8-46': {x: 480, y: 210},
    'g500-r-8-47': {x: 490, y: 210},
    'g500-r-8-48': {x: 500, y: 210},
    'g500-r-8-49': {x: 510, y: 210},
    'g500-r-8-50': {x: 520, y: 210},

    'g500-l-9-1': {x: 30, y: 225},
    'g500-l-9-2': {x: 40, y: 225},
    'g500-l-9-3': {x: 50, y: 225},
    'g500-l-9-4': {x: 60, y: 225},
    'g500-l-9-5': {x: 70, y: 225},
    'g500-l-9-6': {x: 80, y: 225},
    'g500-l-9-7': {x: 90, y: 225},
    'g500-l-9-8': {x: 100, y: 225},
    'g500-l-9-9': {x: 110, y: 225},
    'g500-l-9-10': {x: 120, y: 225},
    'g500-l-9-11': {x: 130, y: 225},
    'g500-l-9-12': {x: 140, y: 225},
    'g500-l-9-13': {x: 150, y: 225},
    'g500-l-9-14': {x: 160, y: 225},
    'g500-l-9-15': {x: 170, y: 225},
    'g500-l-9-16': {x: 180, y: 225},
    'g500-l-9-17': {x: 190, y: 225},
    'g500-l-9-18': {x: 200, y: 225},
    'g500-l-9-19': {x: 210, y: 225},
    'g500-l-9-20': {x: 220, y: 225},
    'g500-l-9-21': {x: 230, y: 225},
    'g500-l-9-22': {x: 240, y: 225},
    'g500-l-9-23': {x: 250, y: 225},
    'g500-l-9-24': {x: 260, y: 225},
    'g500-l-9-25': {x: 270, y: 225},
    'g500-r-9-26': {x: 280, y: 225},
    'g500-r-9-27': {x: 290, y: 225},
    'g500-r-9-28': {x: 300, y: 225},
    'g500-r-9-29': {x: 310, y: 225},
    'g500-r-9-30': {x: 320, y: 225},
    'g500-r-9-31': {x: 330, y: 225},
    'g500-r-9-32': {x: 340, y: 225},
    'g500-r-9-33': {x: 350, y: 225},
    'g500-r-9-34': {x: 360, y: 225},
    'g500-r-9-35': {x: 370, y: 225},
    'g500-r-9-36': {x: 380, y: 225},
    'g500-r-9-37': {x: 390, y: 225},
    'g500-r-9-38': {x: 400, y: 225},
    'g500-r-9-39': {x: 410, y: 225},
    'g500-r-9-40': {x: 420, y: 225},
    'g500-r-9-41': {x: 430, y: 225},
    'g500-r-9-42': {x: 440, y: 225},
    'g500-r-9-43': {x: 450, y: 225},
    'g500-r-9-44': {x: 460, y: 225},
    'g500-r-9-45': {x: 470, y: 225},
    'g500-r-9-46': {x: 480, y: 225},
    'g500-r-9-47': {x: 490, y: 225},
    'g500-r-9-48': {x: 500, y: 225},
    'g500-r-9-49': {x: 510, y: 225},
    'g500-r-9-50': {x: 520, y: 225},

    'g500-l-10-1': {x: 30, y: 240},
    'g500-l-10-2': {x: 40, y: 240},
    'g500-l-10-3': {x: 50, y: 240},
    'g500-l-10-4': {x: 60, y: 240},
    'g500-l-10-5': {x: 70, y: 240},
    'g500-l-10-6': {x: 80, y: 240},
    'g500-l-10-7': {x: 90, y: 240},
    'g500-l-10-8': {x: 100, y: 240},
    'g500-l-10-9': {x: 110, y: 240},
    'g500-l-10-10': {x: 120, y: 240},
    'g500-l-10-11': {x: 130, y: 240},
    'g500-l-10-12': {x: 140, y: 240},
    'g500-l-10-13': {x: 150, y: 240},
    'g500-l-10-14': {x: 160, y: 240},
    'g500-l-10-15': {x: 170, y: 240},
    'g500-l-10-16': {x: 180, y: 240},
    'g500-l-10-17': {x: 190, y: 240},
    'g500-l-10-18': {x: 200, y: 240},
    'g500-l-10-19': {x: 210, y: 240},
    'g500-l-10-20': {x: 220, y: 240},
    'g500-l-10-21': {x: 230, y: 240},
    'g500-l-10-22': {x: 240, y: 240},
    'g500-l-10-23': {x: 250, y: 240},
    'g500-l-10-24': {x: 260, y: 240},
    'g500-l-10-25': {x: 270, y: 240},
    'g500-r-10-26': {x: 280, y: 240},
    'g500-r-10-27': {x: 290, y: 240},
    'g500-r-10-28': {x: 300, y: 240},
    'g500-r-10-29': {x: 310, y: 240},
    'g500-r-10-30': {x: 320, y: 240},
    'g500-r-10-31': {x: 330, y: 240},
    'g500-r-10-32': {x: 340, y: 240},
    'g500-r-10-33': {x: 350, y: 240},
    'g500-r-10-34': {x: 360, y: 240},
    'g500-r-10-35': {x: 370, y: 240},
    'g500-r-10-36': {x: 380, y: 240},
    'g500-r-10-37': {x: 390, y: 240},
    'g500-r-10-38': {x: 400, y: 240},
    'g500-r-10-39': {x: 410, y: 240},
    'g500-r-10-40': {x: 420, y: 240},
    'g500-r-10-41': {x: 430, y: 240},
    'g500-r-10-42': {x: 440, y: 240},
    'g500-r-10-43': {x: 450, y: 240},
    'g500-r-10-44': {x: 460, y: 240},
    'g500-r-10-45': {x: 470, y: 240},
    'g500-r-10-46': {x: 480, y: 240},
    'g500-r-10-47': {x: 490, y: 240},
    'g500-r-10-48': {x: 500, y: 240},
    'g500-r-10-49': {x: 510, y: 240},
    'g500-r-10-50': {x: 520, y: 240},


    //GOSTOVANJA 1200
    'g1200-l-1-1': {x: 30, y: 10},
    'g1200-l-1-2': {x: 40, y: 10},
    'g1200-l-1-3': {x: 50, y: 10},
    'g1200-l-1-4': {x: 60, y: 10},
    'g1200-l-1-5': {x: 70, y: 10},
    'g1200-l-1-6': {x: 80, y: 10},
    'g1200-l-1-7': {x: 90, y: 10},
    'g1200-l-1-8': {x: 100, y: 10},
    'g1200-l-1-9': {x: 110, y: 10},
    'g1200-l-1-10': {x: 120, y: 10},
    'g1200-l-1-11': {x: 130, y: 10},
    'g1200-l-1-12': {x: 140, y: 10},
    'g1200-l-1-13': {x: 150, y: 10},
    'g1200-l-1-14': {x: 160, y: 10},
    'g1200-l-1-15': {x: 170, y: 10},
    'g1200-l-1-16': {x: 180, y: 10},
    'g1200-l-1-17': {x: 190, y: 10},
    'g1200-l-1-18': {x: 200, y: 10},
    'g1200-l-1-19': {x: 210, y: 10},
    'g1200-l-1-20': {x: 220, y: 10},
    'g1200-l-1-21': {x: 230, y: 10},
    'g1200-l-1-22': {x: 240, y: 10},
    'g1200-l-1-23': {x: 250, y: 10},
    'g1200-l-1-24': {x: 260, y: 10},
    'g1200-l-1-25': {x: 270, y: 10},
    'g1200-r-1-26': {x: 280, y: 10},
    'g1200-r-1-27': {x: 290, y: 10},
    'g1200-r-1-28': {x: 300, y: 10},
    'g1200-r-1-29': {x: 310, y: 10},
    'g1200-r-1-30': {x: 320, y: 10},
    'g1200-r-1-31': {x: 330, y: 10},
    'g1200-r-1-32': {x: 340, y: 10},
    'g1200-r-1-33': {x: 350, y: 10},
    'g1200-r-1-34': {x: 360, y: 10},
    'g1200-r-1-35': {x: 370, y: 10},
    'g1200-r-1-36': {x: 380, y: 10},
    'g1200-r-1-37': {x: 390, y: 10},
    'g1200-r-1-38': {x: 400, y: 10},
    'g1200-r-1-39': {x: 410, y: 10},
    'g1200-r-1-40': {x: 420, y: 10},
    'g1200-r-1-41': {x: 430, y: 10},
    'g1200-r-1-42': {x: 440, y: 10},
    'g1200-r-1-43': {x: 450, y: 10},
    'g1200-r-1-44': {x: 460, y: 10},
    'g1200-r-1-45': {x: 470, y: 10},
    'g1200-r-1-46': {x: 480, y: 10},
    'g1200-r-1-47': {x: 490, y: 10},
    'g1200-r-1-48': {x: 500, y: 10},
    'g1200-r-1-49': {x: 510, y: 10},
    'g1200-r-1-50': {x: 520, y: 10},

    'g1200-l-2-1': {x: 30, y: 25},
    'g1200-l-2-2': {x: 40, y: 25},
    'g1200-l-2-3': {x: 50, y: 25},
    'g1200-l-2-4': {x: 60, y: 25},
    'g1200-l-2-5': {x: 70, y: 25},
    'g1200-l-2-6': {x: 80, y: 25},
    'g1200-l-2-7': {x: 90, y: 25},
    'g1200-l-2-8': {x: 100, y: 25},
    'g1200-l-2-9': {x: 110, y: 25},
    'g1200-l-2-10': {x: 120, y: 25},
    'g1200-l-2-11': {x: 130, y: 25},
    'g1200-l-2-12': {x: 140, y: 25},
    'g1200-l-2-13': {x: 150, y: 25},
    'g1200-l-2-14': {x: 160, y: 25},
    'g1200-l-2-15': {x: 170, y: 25},
    'g1200-l-2-16': {x: 180, y: 25},
    'g1200-l-2-17': {x: 190, y: 25},
    'g1200-l-2-18': {x: 200, y: 25},
    'g1200-l-2-19': {x: 210, y: 25},
    'g1200-l-2-20': {x: 220, y: 25},
    'g1200-l-2-21': {x: 230, y: 25},
    'g1200-l-2-22': {x: 240, y: 25},
    'g1200-l-2-23': {x: 250, y: 25},
    'g1200-l-2-24': {x: 260, y: 25},
    'g1200-l-2-25': {x: 270, y: 25},
    'g1200-r-2-26': {x: 280, y: 25},
    'g1200-r-2-27': {x: 290, y: 25},
    'g1200-r-2-28': {x: 300, y: 25},
    'g1200-r-2-29': {x: 310, y: 25},
    'g1200-r-2-30': {x: 320, y: 25},
    'g1200-r-2-31': {x: 330, y: 25},
    'g1200-r-2-32': {x: 340, y: 25},
    'g1200-r-2-33': {x: 350, y: 25},
    'g1200-r-2-34': {x: 360, y: 25},
    'g1200-r-2-35': {x: 370, y: 25},
    'g1200-r-2-36': {x: 380, y: 25},
    'g1200-r-2-37': {x: 390, y: 25},
    'g1200-r-2-38': {x: 400, y: 25},
    'g1200-r-2-39': {x: 410, y: 25},
    'g1200-r-2-40': {x: 420, y: 25},
    'g1200-r-2-41': {x: 430, y: 25},
    'g1200-r-2-42': {x: 440, y: 25},
    'g1200-r-2-43': {x: 450, y: 25},
    'g1200-r-2-44': {x: 460, y: 25},
    'g1200-r-2-45': {x: 470, y: 25},
    'g1200-r-2-46': {x: 480, y: 25},
    'g1200-r-2-47': {x: 490, y: 25},
    'g1200-r-2-48': {x: 500, y: 25},
    'g1200-r-2-49': {x: 510, y: 25},
    'g1200-r-2-50': {x: 520, y: 25},

    'g1200-l-3-1': {x: 30, y: 40},
    'g1200-l-3-2': {x: 40, y: 40},
    'g1200-l-3-3': {x: 50, y: 40},
    'g1200-l-3-4': {x: 60, y: 40},
    'g1200-l-3-5': {x: 70, y: 40},
    'g1200-l-3-6': {x: 80, y: 40},
    'g1200-l-3-7': {x: 90, y: 40},
    'g1200-l-3-8': {x: 100, y: 40},
    'g1200-l-3-9': {x: 110, y: 40},
    'g1200-l-3-10': {x: 120, y: 40},
    'g1200-l-3-11': {x: 130, y: 40},
    'g1200-l-3-12': {x: 140, y: 40},
    'g1200-l-3-13': {x: 150, y: 40},
    'g1200-l-3-14': {x: 160, y: 40},
    'g1200-l-3-15': {x: 170, y: 40},
    'g1200-l-3-16': {x: 180, y: 40},
    'g1200-l-3-17': {x: 190, y: 40},
    'g1200-l-3-18': {x: 200, y: 40},
    'g1200-l-3-19': {x: 210, y: 40},
    'g1200-l-3-20': {x: 220, y: 40},
    'g1200-l-3-21': {x: 230, y: 40},
    'g1200-l-3-22': {x: 240, y: 40},
    'g1200-l-3-23': {x: 250, y: 40},
    'g1200-l-3-24': {x: 260, y: 40},
    'g1200-l-3-25': {x: 270, y: 40},
    'g1200-r-3-26': {x: 280, y: 40},
    'g1200-r-3-27': {x: 290, y: 40},
    'g1200-r-3-28': {x: 300, y: 40},
    'g1200-r-3-29': {x: 310, y: 40},
    'g1200-r-3-30': {x: 320, y: 40},
    'g1200-r-3-31': {x: 330, y: 40},
    'g1200-r-3-32': {x: 340, y: 40},
    'g1200-r-3-33': {x: 350, y: 40},
    'g1200-r-3-34': {x: 360, y: 40},
    'g1200-r-3-35': {x: 370, y: 40},
    'g1200-r-3-36': {x: 380, y: 40},
    'g1200-r-3-37': {x: 390, y: 40},
    'g1200-r-3-38': {x: 400, y: 40},
    'g1200-r-3-39': {x: 410, y: 40},
    'g1200-r-3-40': {x: 420, y: 40},
    'g1200-r-3-41': {x: 430, y: 40},
    'g1200-r-3-42': {x: 440, y: 40},
    'g1200-r-3-43': {x: 450, y: 40},
    'g1200-r-3-44': {x: 460, y: 40},
    'g1200-r-3-45': {x: 470, y: 40},
    'g1200-r-3-46': {x: 480, y: 40},
    'g1200-r-3-47': {x: 490, y: 40},
    'g1200-r-3-48': {x: 500, y: 40},
    'g1200-r-3-49': {x: 510, y: 40},
    'g1200-r-3-50': {x: 520, y: 40},

    'g1200-l-4-1': {x: 30, y: 55},
    'g1200-l-4-2': {x: 40, y: 55},
    'g1200-l-4-3': {x: 50, y: 55},
    'g1200-l-4-4': {x: 60, y: 55},
    'g1200-l-4-5': {x: 70, y: 55},
    'g1200-l-4-6': {x: 80, y: 55},
    'g1200-l-4-7': {x: 90, y: 55},
    'g1200-l-4-8': {x: 100, y: 55},
    'g1200-l-4-9': {x: 110, y: 55},
    'g1200-l-4-10': {x: 120, y: 55},
    'g1200-l-4-11': {x: 130, y: 55},
    'g1200-l-4-12': {x: 140, y: 55},
    'g1200-l-4-13': {x: 150, y: 55},
    'g1200-l-4-14': {x: 160, y: 55},
    'g1200-l-4-15': {x: 170, y: 55},
    'g1200-l-4-16': {x: 180, y: 55},
    'g1200-l-4-17': {x: 190, y: 55},
    'g1200-l-4-18': {x: 200, y: 55},
    'g1200-l-4-19': {x: 210, y: 55},
    'g1200-l-4-20': {x: 220, y: 55},
    'g1200-l-4-21': {x: 230, y: 55},
    'g1200-l-4-22': {x: 240, y: 55},
    'g1200-l-4-23': {x: 250, y: 55},
    'g1200-l-4-24': {x: 260, y: 55},
    'g1200-l-4-25': {x: 270, y: 55},
    'g1200-r-4-26': {x: 280, y: 55},
    'g1200-r-4-27': {x: 290, y: 55},
    'g1200-r-4-28': {x: 300, y: 55},
    'g1200-r-4-29': {x: 310, y: 55},
    'g1200-r-4-30': {x: 320, y: 55},
    'g1200-r-4-31': {x: 330, y: 55},
    'g1200-r-4-32': {x: 340, y: 55},
    'g1200-r-4-33': {x: 350, y: 55},
    'g1200-r-4-34': {x: 360, y: 55},
    'g1200-r-4-35': {x: 370, y: 55},
    'g1200-r-4-36': {x: 380, y: 55},
    'g1200-r-4-37': {x: 390, y: 55},
    'g1200-r-4-38': {x: 400, y: 55},
    'g1200-r-4-39': {x: 410, y: 55},
    'g1200-r-4-40': {x: 420, y: 55},
    'g1200-r-4-41': {x: 430, y: 55},
    'g1200-r-4-42': {x: 440, y: 55},
    'g1200-r-4-43': {x: 450, y: 55},
    'g1200-r-4-44': {x: 460, y: 55},
    'g1200-r-4-45': {x: 470, y: 55},
    'g1200-r-4-46': {x: 480, y: 55},
    'g1200-r-4-47': {x: 490, y: 55},
    'g1200-r-4-48': {x: 500, y: 55},
    'g1200-r-4-49': {x: 510, y: 55},
    'g1200-r-4-50': {x: 520, y: 55},

    'g1200-l-5-1': {x: 30, y: 70},
    'g1200-l-5-2': {x: 40, y: 70},
    'g1200-l-5-3': {x: 50, y: 70},
    'g1200-l-5-4': {x: 60, y: 70},
    'g1200-l-5-5': {x: 70, y: 70},
    'g1200-l-5-6': {x: 80, y: 70},
    'g1200-l-5-7': {x: 90, y: 70},
    'g1200-l-5-8': {x: 100, y: 70},
    'g1200-l-5-9': {x: 110, y: 70},
    'g1200-l-5-10': {x: 120, y: 70},
    'g1200-l-5-11': {x: 130, y: 70},
    'g1200-l-5-12': {x: 140, y: 70},
    'g1200-l-5-13': {x: 150, y: 70},
    'g1200-l-5-14': {x: 160, y: 70},
    'g1200-l-5-15': {x: 170, y: 70},
    'g1200-l-5-16': {x: 180, y: 70},
    'g1200-l-5-17': {x: 190, y: 70},
    'g1200-l-5-18': {x: 200, y: 70},
    'g1200-l-5-19': {x: 210, y: 70},
    'g1200-l-5-20': {x: 220, y: 70},
    'g1200-l-5-21': {x: 230, y: 70},
    'g1200-l-5-22': {x: 240, y: 70},
    'g1200-l-5-23': {x: 250, y: 70},
    'g1200-l-5-24': {x: 260, y: 70},
    'g1200-l-5-25': {x: 270, y: 70},
    'g1200-r-5-26': {x: 280, y: 70},
    'g1200-r-5-27': {x: 290, y: 70},
    'g1200-r-5-28': {x: 300, y: 70},
    'g1200-r-5-29': {x: 310, y: 70},
    'g1200-r-5-30': {x: 320, y: 70},
    'g1200-r-5-31': {x: 330, y: 70},
    'g1200-r-5-32': {x: 340, y: 70},
    'g1200-r-5-33': {x: 350, y: 70},
    'g1200-r-5-34': {x: 360, y: 70},
    'g1200-r-5-35': {x: 370, y: 70},
    'g1200-r-5-36': {x: 380, y: 70},
    'g1200-r-5-37': {x: 390, y: 70},
    'g1200-r-5-38': {x: 400, y: 70},
    'g1200-r-5-39': {x: 410, y: 70},
    'g1200-r-5-40': {x: 420, y: 70},
    'g1200-r-5-41': {x: 430, y: 70},
    'g1200-r-5-42': {x: 440, y: 70},
    'g1200-r-5-43': {x: 450, y: 70},
    'g1200-r-5-44': {x: 460, y: 70},
    'g1200-r-5-45': {x: 470, y: 70},
    'g1200-r-5-46': {x: 480, y: 70},
    'g1200-r-5-47': {x: 490, y: 70},
    'g1200-r-5-48': {x: 500, y: 70},
    'g1200-r-5-49': {x: 510, y: 70},
    'g1200-r-5-50': {x: 520, y: 70},

    'g1200-l-6-1': {x: 30, y: 85},
    'g1200-l-6-2': {x: 40, y: 85},
    'g1200-l-6-3': {x: 50, y: 85},
    'g1200-l-6-4': {x: 60, y: 85},
    'g1200-l-6-5': {x: 70, y: 85},
    'g1200-l-6-6': {x: 80, y: 85},
    'g1200-l-6-7': {x: 90, y: 85},
    'g1200-l-6-8': {x: 100, y: 85},
    'g1200-l-6-9': {x: 110, y: 85},
    'g1200-l-6-10': {x: 120, y: 85},
    'g1200-l-6-11': {x: 130, y: 85},
    'g1200-l-6-12': {x: 140, y: 85},
    'g1200-l-6-13': {x: 150, y: 85},
    'g1200-l-6-14': {x: 160, y: 85},
    'g1200-l-6-15': {x: 170, y: 85},
    'g1200-l-6-16': {x: 180, y: 85},
    'g1200-l-6-17': {x: 190, y: 85},
    'g1200-l-6-18': {x: 200, y: 85},
    'g1200-l-6-19': {x: 210, y: 85},
    'g1200-l-6-20': {x: 220, y: 85},
    'g1200-l-6-21': {x: 230, y: 85},
    'g1200-l-6-22': {x: 240, y: 85},
    'g1200-l-6-23': {x: 250, y: 85},
    'g1200-l-6-24': {x: 260, y: 85},
    'g1200-l-6-25': {x: 270, y: 85},
    'g1200-r-6-26': {x: 280, y: 85},
    'g1200-r-6-27': {x: 290, y: 85},
    'g1200-r-6-28': {x: 300, y: 85},
    'g1200-r-6-29': {x: 310, y: 85},
    'g1200-r-6-30': {x: 320, y: 85},
    'g1200-r-6-31': {x: 330, y: 85},
    'g1200-r-6-32': {x: 340, y: 85},
    'g1200-r-6-33': {x: 350, y: 85},
    'g1200-r-6-34': {x: 360, y: 85},
    'g1200-r-6-35': {x: 370, y: 85},
    'g1200-r-6-36': {x: 380, y: 85},
    'g1200-r-6-37': {x: 390, y: 85},
    'g1200-r-6-38': {x: 400, y: 85},
    'g1200-r-6-39': {x: 410, y: 85},
    'g1200-r-6-40': {x: 420, y: 85},
    'g1200-r-6-41': {x: 430, y: 85},
    'g1200-r-6-42': {x: 440, y: 85},
    'g1200-r-6-43': {x: 450, y: 85},
    'g1200-r-6-44': {x: 460, y: 85},
    'g1200-r-6-45': {x: 470, y: 85},
    'g1200-r-6-46': {x: 480, y: 85},
    'g1200-r-6-47': {x: 490, y: 85},
    'g1200-r-6-48': {x: 500, y: 85},
    'g1200-r-6-49': {x: 510, y: 85},
    'g1200-r-6-50': {x: 520, y: 85},

    'g1200-l-7-1': {x: 30, y: 100},
    'g1200-l-7-2': {x: 40, y: 100},
    'g1200-l-7-3': {x: 50, y: 100},
    'g1200-l-7-4': {x: 60, y: 100},
    'g1200-l-7-5': {x: 70, y: 100},
    'g1200-l-7-6': {x: 80, y: 100},
    'g1200-l-7-7': {x: 90, y: 100},
    'g1200-l-7-8': {x: 100, y: 100},
    'g1200-l-7-9': {x: 110, y: 100},
    'g1200-l-7-10': {x: 120, y: 100},
    'g1200-l-7-11': {x: 130, y: 100},
    'g1200-l-7-12': {x: 140, y: 100},
    'g1200-l-7-13': {x: 150, y: 100},
    'g1200-l-7-14': {x: 160, y: 100},
    'g1200-l-7-15': {x: 170, y: 100},
    'g1200-l-7-16': {x: 180, y: 100},
    'g1200-l-7-17': {x: 190, y: 100},
    'g1200-l-7-18': {x: 200, y: 100},
    'g1200-l-7-19': {x: 210, y: 100},
    'g1200-l-7-20': {x: 220, y: 100},
    'g1200-l-7-21': {x: 230, y: 100},
    'g1200-l-7-22': {x: 240, y: 100},
    'g1200-l-7-23': {x: 250, y: 100},
    'g1200-l-7-24': {x: 260, y: 100},
    'g1200-l-7-25': {x: 270, y: 100},
    'g1200-r-7-26': {x: 280, y: 100},
    'g1200-r-7-27': {x: 290, y: 100},
    'g1200-r-7-28': {x: 300, y: 100},
    'g1200-r-7-29': {x: 310, y: 100},
    'g1200-r-7-30': {x: 320, y: 100},
    'g1200-r-7-31': {x: 330, y: 100},
    'g1200-r-7-32': {x: 340, y: 100},
    'g1200-r-7-33': {x: 350, y: 100},
    'g1200-r-7-34': {x: 360, y: 100},
    'g1200-r-7-35': {x: 370, y: 100},
    'g1200-r-7-36': {x: 380, y: 100},
    'g1200-r-7-37': {x: 390, y: 100},
    'g1200-r-7-38': {x: 400, y: 100},
    'g1200-r-7-39': {x: 410, y: 100},
    'g1200-r-7-40': {x: 420, y: 100},
    'g1200-r-7-41': {x: 430, y: 100},
    'g1200-r-7-42': {x: 440, y: 100},
    'g1200-r-7-43': {x: 450, y: 100},
    'g1200-r-7-44': {x: 460, y: 100},
    'g1200-r-7-45': {x: 470, y: 100},
    'g1200-r-7-46': {x: 480, y: 100},
    'g1200-r-7-47': {x: 490, y: 100},
    'g1200-r-7-48': {x: 500, y: 100},
    'g1200-r-7-49': {x: 510, y: 100},
    'g1200-r-7-50': {x: 520, y: 100},

    'g1200-l-8-1': {x: 30, y: 115},
    'g1200-l-8-2': {x: 40, y: 115},
    'g1200-l-8-3': {x: 50, y: 115},
    'g1200-l-8-4': {x: 60, y: 115},
    'g1200-l-8-5': {x: 70, y: 115},
    'g1200-l-8-6': {x: 80, y: 115},
    'g1200-l-8-7': {x: 90, y: 115},
    'g1200-l-8-8': {x: 100, y: 115},
    'g1200-l-8-9': {x: 110, y: 115},
    'g1200-l-8-10': {x: 120, y: 115},
    'g1200-l-8-11': {x: 130, y: 115},
    'g1200-l-8-12': {x: 140, y: 115},
    'g1200-l-8-13': {x: 150, y: 115},
    'g1200-l-8-14': {x: 160, y: 115},
    'g1200-l-8-15': {x: 170, y: 115},
    'g1200-l-8-16': {x: 180, y: 115},
    'g1200-l-8-17': {x: 190, y: 115},
    'g1200-l-8-18': {x: 200, y: 115},
    'g1200-l-8-19': {x: 210, y: 115},
    'g1200-l-8-20': {x: 220, y: 115},
    'g1200-l-8-21': {x: 230, y: 115},
    'g1200-l-8-22': {x: 240, y: 115},
    'g1200-l-8-23': {x: 250, y: 115},
    'g1200-l-8-24': {x: 260, y: 115},
    'g1200-l-8-25': {x: 270, y: 115},
    'g1200-r-8-26': {x: 280, y: 115},
    'g1200-r-8-27': {x: 290, y: 115},
    'g1200-r-8-28': {x: 300, y: 115},
    'g1200-r-8-29': {x: 310, y: 115},
    'g1200-r-8-30': {x: 320, y: 115},
    'g1200-r-8-31': {x: 330, y: 115},
    'g1200-r-8-32': {x: 340, y: 115},
    'g1200-r-8-33': {x: 350, y: 115},
    'g1200-r-8-34': {x: 360, y: 115},
    'g1200-r-8-35': {x: 370, y: 115},
    'g1200-r-8-36': {x: 380, y: 115},
    'g1200-r-8-37': {x: 390, y: 115},
    'g1200-r-8-38': {x: 400, y: 115},
    'g1200-r-8-39': {x: 410, y: 115},
    'g1200-r-8-40': {x: 420, y: 115},
    'g1200-r-8-41': {x: 430, y: 115},
    'g1200-r-8-42': {x: 440, y: 115},
    'g1200-r-8-43': {x: 450, y: 115},
    'g1200-r-8-44': {x: 460, y: 115},
    'g1200-r-8-45': {x: 470, y: 115},
    'g1200-r-8-46': {x: 480, y: 115},
    'g1200-r-8-47': {x: 490, y: 115},
    'g1200-r-8-48': {x: 500, y: 115},
    'g1200-r-8-49': {x: 510, y: 115},
    'g1200-r-8-50': {x: 520, y: 115},

    'g1200-l-9-1': {x: 30, y: 130},
    'g1200-l-9-2': {x: 40, y: 130},
    'g1200-l-9-3': {x: 50, y: 130},
    'g1200-l-9-4': {x: 60, y: 130},
    'g1200-l-9-5': {x: 70, y: 130},
    'g1200-l-9-6': {x: 80, y: 130},
    'g1200-l-9-7': {x: 90, y: 130},
    'g1200-l-9-8': {x: 100, y: 130},
    'g1200-l-9-9': {x: 110, y: 130},
    'g1200-l-9-10': {x: 120, y: 130},
    'g1200-l-9-11': {x: 130, y: 130},
    'g1200-l-9-12': {x: 140, y: 130},
    'g1200-l-9-13': {x: 150, y: 130},
    'g1200-l-9-14': {x: 160, y: 130},
    'g1200-l-9-15': {x: 170, y: 130},
    'g1200-l-9-16': {x: 180, y: 130},
    'g1200-l-9-17': {x: 190, y: 130},
    'g1200-l-9-18': {x: 200, y: 130},
    'g1200-l-9-19': {x: 210, y: 130},
    'g1200-l-9-20': {x: 220, y: 130},
    'g1200-l-9-21': {x: 230, y: 130},
    'g1200-l-9-22': {x: 240, y: 130},
    'g1200-l-9-23': {x: 250, y: 130},
    'g1200-l-9-24': {x: 260, y: 130},
    'g1200-l-9-25': {x: 270, y: 130},
    'g1200-r-9-26': {x: 280, y: 130},
    'g1200-r-9-27': {x: 290, y: 130},
    'g1200-r-9-28': {x: 300, y: 130},
    'g1200-r-9-29': {x: 310, y: 130},
    'g1200-r-9-30': {x: 320, y: 130},
    'g1200-r-9-31': {x: 330, y: 130},
    'g1200-r-9-32': {x: 340, y: 130},
    'g1200-r-9-33': {x: 350, y: 130},
    'g1200-r-9-34': {x: 360, y: 130},
    'g1200-r-9-35': {x: 370, y: 130},
    'g1200-r-9-36': {x: 380, y: 130},
    'g1200-r-9-37': {x: 390, y: 130},
    'g1200-r-9-38': {x: 400, y: 130},
    'g1200-r-9-39': {x: 410, y: 130},
    'g1200-r-9-40': {x: 420, y: 130},
    'g1200-r-9-41': {x: 430, y: 130},
    'g1200-r-9-42': {x: 440, y: 130},
    'g1200-r-9-43': {x: 450, y: 130},
    'g1200-r-9-44': {x: 460, y: 130},
    'g1200-r-9-45': {x: 470, y: 130},
    'g1200-r-9-46': {x: 480, y: 130},
    'g1200-r-9-47': {x: 490, y: 130},
    'g1200-r-9-48': {x: 500, y: 130},
    'g1200-r-9-49': {x: 510, y: 130},
    'g1200-r-9-50': {x: 520, y: 130},

    'g1200-l-10-1': {x: 30, y: 145},
    'g1200-l-10-2': {x: 40, y: 145},
    'g1200-l-10-3': {x: 50, y: 145},
    'g1200-l-10-4': {x: 60, y: 145},
    'g1200-l-10-5': {x: 70, y: 145},
    'g1200-l-10-6': {x: 80, y: 145},
    'g1200-l-10-7': {x: 90, y: 145},
    'g1200-l-10-8': {x: 100, y: 145},
    'g1200-l-10-9': {x: 110, y: 145},
    'g1200-l-10-10': {x: 120, y: 145},
    'g1200-l-10-11': {x: 130, y: 145},
    'g1200-l-10-12': {x: 140, y: 145},
    'g1200-l-10-13': {x: 150, y: 145},
    'g1200-l-10-14': {x: 160, y: 145},
    'g1200-l-10-15': {x: 170, y: 145},
    'g1200-l-10-16': {x: 180, y: 145},
    'g1200-l-10-17': {x: 190, y: 145},
    'g1200-l-10-18': {x: 200, y: 145},
    'g1200-l-10-19': {x: 210, y: 145},
    'g1200-l-10-20': {x: 220, y: 145},
    'g1200-l-10-21': {x: 230, y: 145},
    'g1200-l-10-22': {x: 240, y: 145},
    'g1200-l-10-23': {x: 250, y: 145},
    'g1200-l-10-24': {x: 260, y: 145},
    'g1200-l-10-25': {x: 270, y: 145},
    'g1200-r-10-26': {x: 280, y: 145},
    'g1200-r-10-27': {x: 290, y: 145},
    'g1200-r-10-28': {x: 300, y: 145},
    'g1200-r-10-29': {x: 310, y: 145},
    'g1200-r-10-30': {x: 320, y: 145},
    'g1200-r-10-31': {x: 330, y: 145},
    'g1200-r-10-32': {x: 340, y: 145},
    'g1200-r-10-33': {x: 350, y: 145},
    'g1200-r-10-34': {x: 360, y: 145},
    'g1200-r-10-35': {x: 370, y: 145},
    'g1200-r-10-36': {x: 380, y: 145},
    'g1200-r-10-37': {x: 390, y: 145},
    'g1200-r-10-38': {x: 400, y: 145},
    'g1200-r-10-39': {x: 410, y: 145},
    'g1200-r-10-40': {x: 420, y: 145},
    'g1200-r-10-41': {x: 430, y: 145},
    'g1200-r-10-42': {x: 440, y: 145},
    'g1200-r-10-43': {x: 450, y: 145},
    'g1200-r-10-44': {x: 460, y: 145},
    'g1200-r-10-45': {x: 470, y: 145},
    'g1200-r-10-46': {x: 480, y: 145},
    'g1200-r-10-47': {x: 490, y: 145},
    'g1200-r-10-48': {x: 500, y: 145},
    'g1200-r-10-49': {x: 510, y: 145},
    'g1200-r-10-50': {x: 520, y: 145},

    'g1200-l-11-1': {x: 30, y: 160},
    'g1200-l-11-2': {x: 40, y: 160},
    'g1200-l-11-3': {x: 50, y: 160},
    'g1200-l-11-4': {x: 60, y: 160},
    'g1200-l-11-5': {x: 70, y: 160},
    'g1200-l-11-6': {x: 80, y: 160},
    'g1200-l-11-7': {x: 90, y: 160},
    'g1200-l-11-8': {x: 100, y: 160},
    'g1200-l-11-9': {x: 110, y: 160},
    'g1200-l-11-10': {x: 120, y: 160},
    'g1200-l-11-11': {x: 130, y: 160},
    'g1200-l-11-12': {x: 140, y: 160},
    'g1200-l-11-13': {x: 150, y: 160},
    'g1200-l-11-14': {x: 160, y: 160},
    'g1200-l-11-15': {x: 170, y: 160},
    'g1200-l-11-16': {x: 180, y: 160},
    'g1200-l-11-17': {x: 190, y: 160},
    'g1200-l-11-18': {x: 200, y: 160},
    'g1200-l-11-19': {x: 210, y: 160},
    'g1200-l-11-20': {x: 220, y: 160},
    'g1200-l-11-21': {x: 230, y: 160},
    'g1200-l-11-22': {x: 240, y: 160},
    'g1200-l-11-23': {x: 250, y: 160},
    'g1200-l-11-24': {x: 260, y: 160},
    'g1200-l-11-25': {x: 270, y: 160},
    'g1200-r-11-26': {x: 280, y: 160},
    'g1200-r-11-27': {x: 290, y: 160},
    'g1200-r-11-28': {x: 300, y: 160},
    'g1200-r-11-29': {x: 310, y: 160},
    'g1200-r-11-30': {x: 320, y: 160},
    'g1200-r-11-31': {x: 330, y: 160},
    'g1200-r-11-32': {x: 340, y: 160},
    'g1200-r-11-33': {x: 350, y: 160},
    'g1200-r-11-34': {x: 360, y: 160},
    'g1200-r-11-35': {x: 370, y: 160},
    'g1200-r-11-36': {x: 380, y: 160},
    'g1200-r-11-37': {x: 390, y: 160},
    'g1200-r-11-38': {x: 400, y: 160},
    'g1200-r-11-39': {x: 410, y: 160},
    'g1200-r-11-40': {x: 420, y: 160},
    'g1200-r-11-41': {x: 430, y: 160},
    'g1200-r-11-42': {x: 440, y: 160},
    'g1200-r-11-43': {x: 450, y: 160},
    'g1200-r-11-44': {x: 460, y: 160},
    'g1200-r-11-45': {x: 470, y: 160},
    'g1200-r-11-46': {x: 480, y: 160},
    'g1200-r-11-47': {x: 490, y: 160},
    'g1200-r-11-48': {x: 500, y: 160},
    'g1200-r-11-49': {x: 510, y: 160},
    'g1200-r-11-50': {x: 520, y: 160},

    'g1200-l-12-1': {x: 30, y: 175},
    'g1200-l-12-2': {x: 40, y: 175},
    'g1200-l-12-3': {x: 50, y: 175},
    'g1200-l-12-4': {x: 60, y: 175},
    'g1200-l-12-5': {x: 70, y: 175},
    'g1200-l-12-6': {x: 80, y: 175},
    'g1200-l-12-7': {x: 90, y: 175},
    'g1200-l-12-8': {x: 100, y: 175},
    'g1200-l-12-9': {x: 110, y: 175},
    'g1200-l-12-10': {x: 120, y: 175},
    'g1200-l-12-11': {x: 130, y: 175},
    'g1200-l-12-12': {x: 140, y: 175},
    'g1200-l-12-13': {x: 150, y: 175},
    'g1200-l-12-14': {x: 160, y: 175},
    'g1200-l-12-15': {x: 170, y: 175},
    'g1200-l-12-16': {x: 180, y: 175},
    'g1200-l-12-17': {x: 190, y: 175},
    'g1200-l-12-18': {x: 200, y: 175},
    'g1200-l-12-19': {x: 210, y: 175},
    'g1200-l-12-20': {x: 220, y: 175},
    'g1200-l-12-21': {x: 230, y: 175},
    'g1200-l-12-22': {x: 240, y: 175},
    'g1200-l-12-23': {x: 250, y: 175},
    'g1200-l-12-24': {x: 260, y: 175},
    'g1200-l-12-25': {x: 270, y: 175},
    'g1200-r-12-26': {x: 280, y: 175},
    'g1200-r-12-27': {x: 290, y: 175},
    'g1200-r-12-28': {x: 300, y: 175},
    'g1200-r-12-29': {x: 310, y: 175},
    'g1200-r-12-30': {x: 320, y: 175},
    'g1200-r-12-31': {x: 330, y: 175},
    'g1200-r-12-32': {x: 340, y: 175},
    'g1200-r-12-33': {x: 350, y: 175},
    'g1200-r-12-34': {x: 360, y: 175},
    'g1200-r-12-35': {x: 370, y: 175},
    'g1200-r-12-36': {x: 380, y: 175},
    'g1200-r-12-37': {x: 390, y: 175},
    'g1200-r-12-38': {x: 400, y: 175},
    'g1200-r-12-39': {x: 410, y: 175},
    'g1200-r-12-40': {x: 420, y: 175},
    'g1200-r-12-41': {x: 430, y: 175},
    'g1200-r-12-42': {x: 440, y: 175},
    'g1200-r-12-43': {x: 450, y: 175},
    'g1200-r-12-44': {x: 460, y: 175},
    'g1200-r-12-45': {x: 470, y: 175},
    'g1200-r-12-46': {x: 480, y: 175},
    'g1200-r-12-47': {x: 490, y: 175},
    'g1200-r-12-48': {x: 500, y: 175},
    'g1200-r-12-49': {x: 510, y: 175},
    'g1200-r-12-50': {x: 520, y: 175},

    'g1200-l-13-1': {x: 30, y: 190},
    'g1200-l-13-2': {x: 40, y: 190},
    'g1200-l-13-3': {x: 50, y: 190},
    'g1200-l-13-4': {x: 60, y: 190},
    'g1200-l-13-5': {x: 70, y: 190},
    'g1200-l-13-6': {x: 80, y: 190},
    'g1200-l-13-7': {x: 90, y: 190},
    'g1200-l-13-8': {x: 100, y: 190},
    'g1200-l-13-9': {x: 110, y: 190},
    'g1200-l-13-10': {x: 120, y: 190},
    'g1200-l-13-11': {x: 130, y: 190},
    'g1200-l-13-12': {x: 140, y: 190},
    'g1200-l-13-13': {x: 150, y: 190},
    'g1200-l-13-14': {x: 160, y: 190},
    'g1200-l-13-15': {x: 170, y: 190},
    'g1200-l-13-16': {x: 180, y: 190},
    'g1200-l-13-17': {x: 190, y: 190},
    'g1200-l-13-18': {x: 200, y: 190},
    'g1200-l-13-19': {x: 210, y: 190},
    'g1200-l-13-20': {x: 220, y: 190},
    'g1200-l-13-21': {x: 230, y: 190},
    'g1200-l-13-22': {x: 240, y: 190},
    'g1200-l-13-23': {x: 250, y: 190},
    'g1200-l-13-24': {x: 260, y: 190},
    'g1200-l-13-25': {x: 270, y: 190},
    'g1200-r-13-26': {x: 280, y: 190},
    'g1200-r-13-27': {x: 290, y: 190},
    'g1200-r-13-28': {x: 300, y: 190},
    'g1200-r-13-29': {x: 310, y: 190},
    'g1200-r-13-30': {x: 320, y: 190},
    'g1200-r-13-31': {x: 330, y: 190},
    'g1200-r-13-32': {x: 340, y: 190},
    'g1200-r-13-33': {x: 350, y: 190},
    'g1200-r-13-34': {x: 360, y: 190},
    'g1200-r-13-35': {x: 370, y: 190},
    'g1200-r-13-36': {x: 380, y: 190},
    'g1200-r-13-37': {x: 390, y: 190},
    'g1200-r-13-38': {x: 400, y: 190},
    'g1200-r-13-39': {x: 410, y: 190},
    'g1200-r-13-40': {x: 420, y: 190},
    'g1200-r-13-41': {x: 430, y: 190},
    'g1200-r-13-42': {x: 440, y: 190},
    'g1200-r-13-43': {x: 450, y: 190},
    'g1200-r-13-44': {x: 460, y: 190},
    'g1200-r-13-45': {x: 470, y: 190},
    'g1200-r-13-46': {x: 480, y: 190},
    'g1200-r-13-47': {x: 490, y: 190},
    'g1200-r-13-48': {x: 500, y: 190},
    'g1200-r-13-49': {x: 510, y: 190},
    'g1200-r-13-50': {x: 520, y: 190},

    'g1200-l-14-1': {x: 30, y: 205},
    'g1200-l-14-2': {x: 40, y: 205},
    'g1200-l-14-3': {x: 50, y: 205},
    'g1200-l-14-4': {x: 60, y: 205},
    'g1200-l-14-5': {x: 70, y: 205},
    'g1200-l-14-6': {x: 80, y: 205},
    'g1200-l-14-7': {x: 90, y: 205},
    'g1200-l-14-8': {x: 100, y: 205},
    'g1200-l-14-9': {x: 110, y: 205},
    'g1200-l-14-10': {x: 120, y: 205},
    'g1200-l-14-11': {x: 130, y: 205},
    'g1200-l-14-12': {x: 140, y: 205},
    'g1200-l-14-13': {x: 150, y: 205},
    'g1200-l-14-14': {x: 160, y: 205},
    'g1200-l-14-15': {x: 170, y: 205},
    'g1200-l-14-16': {x: 180, y: 205},
    'g1200-l-14-17': {x: 190, y: 205},
    'g1200-l-14-18': {x: 200, y: 205},
    'g1200-l-14-19': {x: 210, y: 205},
    'g1200-l-14-20': {x: 220, y: 205},
    'g1200-l-14-21': {x: 230, y: 205},
    'g1200-l-14-22': {x: 240, y: 205},
    'g1200-l-14-23': {x: 250, y: 205},
    'g1200-l-14-24': {x: 260, y: 205},
    'g1200-l-14-25': {x: 270, y: 205},
    'g1200-r-14-26': {x: 280, y: 205},
    'g1200-r-14-27': {x: 290, y: 205},
    'g1200-r-14-28': {x: 300, y: 205},
    'g1200-r-14-29': {x: 310, y: 205},
    'g1200-r-14-30': {x: 320, y: 205},
    'g1200-r-14-31': {x: 330, y: 205},
    'g1200-r-14-32': {x: 340, y: 205},
    'g1200-r-14-33': {x: 350, y: 205},
    'g1200-r-14-34': {x: 360, y: 205},
    'g1200-r-14-35': {x: 370, y: 205},
    'g1200-r-14-36': {x: 380, y: 205},
    'g1200-r-14-37': {x: 390, y: 205},
    'g1200-r-14-38': {x: 400, y: 205},
    'g1200-r-14-39': {x: 410, y: 205},
    'g1200-r-14-40': {x: 420, y: 205},
    'g1200-r-14-41': {x: 430, y: 205},
    'g1200-r-14-42': {x: 440, y: 205},
    'g1200-r-14-43': {x: 450, y: 205},
    'g1200-r-14-44': {x: 460, y: 205},
    'g1200-r-14-45': {x: 470, y: 205},
    'g1200-r-14-46': {x: 480, y: 205},
    'g1200-r-14-47': {x: 490, y: 205},
    'g1200-r-14-48': {x: 500, y: 205},
    'g1200-r-14-49': {x: 510, y: 205},
    'g1200-r-14-50': {x: 520, y: 205},

    'g1200-l-15-1': {x: 30, y: 220},
    'g1200-l-15-2': {x: 40, y: 220},
    'g1200-l-15-3': {x: 50, y: 220},
    'g1200-l-15-4': {x: 60, y: 220},
    'g1200-l-15-5': {x: 70, y: 220},
    'g1200-l-15-6': {x: 80, y: 220},
    'g1200-l-15-7': {x: 90, y: 220},
    'g1200-l-15-8': {x: 100, y: 220},
    'g1200-l-15-9': {x: 110, y: 220},
    'g1200-l-15-10': {x: 120, y: 220},
    'g1200-l-15-11': {x: 130, y: 220},
    'g1200-l-15-12': {x: 140, y: 220},
    'g1200-l-15-13': {x: 150, y: 220},
    'g1200-l-15-14': {x: 160, y: 220},
    'g1200-l-15-15': {x: 170, y: 220},
    'g1200-l-15-16': {x: 180, y: 220},
    'g1200-l-15-17': {x: 190, y: 220},
    'g1200-l-15-18': {x: 200, y: 220},
    'g1200-l-15-19': {x: 210, y: 220},
    'g1200-l-15-20': {x: 220, y: 220},
    'g1200-l-15-21': {x: 230, y: 220},
    'g1200-l-15-22': {x: 240, y: 220},
    'g1200-l-15-23': {x: 250, y: 220},
    'g1200-l-15-24': {x: 260, y: 220},
    'g1200-l-15-25': {x: 270, y: 220},
    'g1200-r-15-26': {x: 280, y: 220},
    'g1200-r-15-27': {x: 290, y: 220},
    'g1200-r-15-28': {x: 300, y: 220},
    'g1200-r-15-29': {x: 310, y: 220},
    'g1200-r-15-30': {x: 320, y: 220},
    'g1200-r-15-31': {x: 330, y: 220},
    'g1200-r-15-32': {x: 340, y: 220},
    'g1200-r-15-33': {x: 350, y: 220},
    'g1200-r-15-34': {x: 360, y: 220},
    'g1200-r-15-35': {x: 370, y: 220},
    'g1200-r-15-36': {x: 380, y: 220},
    'g1200-r-15-37': {x: 390, y: 220},
    'g1200-r-15-38': {x: 400, y: 220},
    'g1200-r-15-39': {x: 410, y: 220},
    'g1200-r-15-40': {x: 420, y: 220},
    'g1200-r-15-41': {x: 430, y: 220},
    'g1200-r-15-42': {x: 440, y: 220},
    'g1200-r-15-43': {x: 450, y: 220},
    'g1200-r-15-44': {x: 460, y: 220},
    'g1200-r-15-45': {x: 470, y: 220},
    'g1200-r-15-46': {x: 480, y: 220},
    'g1200-r-15-47': {x: 490, y: 220},
    'g1200-r-15-48': {x: 500, y: 220},
    'g1200-r-15-49': {x: 510, y: 220},
    'g1200-r-15-50': {x: 520, y: 220},

    'g1200-l-16-1': {x: 30, y: 235},
    'g1200-l-16-2': {x: 40, y: 235},
    'g1200-l-16-3': {x: 50, y: 235},
    'g1200-l-16-4': {x: 60, y: 235},
    'g1200-l-16-5': {x: 70, y: 235},
    'g1200-l-16-6': {x: 80, y: 235},
    'g1200-l-16-7': {x: 90, y: 235},
    'g1200-l-16-8': {x: 100, y: 235},
    'g1200-l-16-9': {x: 110, y: 235},
    'g1200-l-16-10': {x: 120, y: 235},
    'g1200-l-16-11': {x: 130, y: 235},
    'g1200-l-16-12': {x: 140, y: 235},
    'g1200-l-16-13': {x: 150, y: 235},
    'g1200-l-16-14': {x: 160, y: 235},
    'g1200-l-16-15': {x: 170, y: 235},
    'g1200-l-16-16': {x: 180, y: 235},
    'g1200-l-16-17': {x: 190, y: 235},
    'g1200-l-16-18': {x: 200, y: 235},
    'g1200-l-16-19': {x: 210, y: 235},
    'g1200-l-16-20': {x: 220, y: 235},
    'g1200-l-16-21': {x: 230, y: 235},
    'g1200-l-16-22': {x: 240, y: 235},
    'g1200-l-16-23': {x: 250, y: 235},
    'g1200-l-16-24': {x: 260, y: 235},
    'g1200-l-16-25': {x: 270, y: 235},
    'g1200-r-16-26': {x: 280, y: 235},
    'g1200-r-16-27': {x: 290, y: 235},
    'g1200-r-16-28': {x: 300, y: 235},
    'g1200-r-16-29': {x: 310, y: 235},
    'g1200-r-16-30': {x: 320, y: 235},
    'g1200-r-16-31': {x: 330, y: 235},
    'g1200-r-16-32': {x: 340, y: 235},
    'g1200-r-16-33': {x: 350, y: 235},
    'g1200-r-16-34': {x: 360, y: 235},
    'g1200-r-16-35': {x: 370, y: 235},
    'g1200-r-16-36': {x: 380, y: 235},
    'g1200-r-16-37': {x: 390, y: 235},
    'g1200-r-16-38': {x: 400, y: 235},
    'g1200-r-16-39': {x: 410, y: 235},
    'g1200-r-16-40': {x: 420, y: 235},
    'g1200-r-16-41': {x: 430, y: 235},
    'g1200-r-16-42': {x: 440, y: 235},
    'g1200-r-16-43': {x: 450, y: 235},
    'g1200-r-16-44': {x: 460, y: 235},
    'g1200-r-16-45': {x: 470, y: 235},
    'g1200-r-16-46': {x: 480, y: 235},
    'g1200-r-16-47': {x: 490, y: 235},
    'g1200-r-16-48': {x: 500, y: 235},
    'g1200-r-16-49': {x: 510, y: 235},
    'g1200-r-16-50': {x: 520, y: 235},

    'g1200-l-17-1': {x: 30, y: 250},
    'g1200-l-17-2': {x: 40, y: 250},
    'g1200-l-17-3': {x: 50, y: 250},
    'g1200-l-17-4': {x: 60, y: 250},
    'g1200-l-17-5': {x: 70, y: 250},
    'g1200-l-17-6': {x: 80, y: 250},
    'g1200-l-17-7': {x: 90, y: 250},
    'g1200-l-17-8': {x: 100, y: 250},
    'g1200-l-17-9': {x: 110, y: 250},
    'g1200-l-17-10': {x: 120, y: 250},
    'g1200-l-17-11': {x: 130, y: 250},
    'g1200-l-17-12': {x: 140, y: 250},
    'g1200-l-17-13': {x: 150, y: 250},
    'g1200-l-17-14': {x: 160, y: 250},
    'g1200-l-17-15': {x: 170, y: 250},
    'g1200-l-17-16': {x: 180, y: 250},
    'g1200-l-17-17': {x: 190, y: 250},
    'g1200-l-17-18': {x: 200, y: 250},
    'g1200-l-17-19': {x: 210, y: 250},
    'g1200-l-17-20': {x: 220, y: 250},
    'g1200-l-17-21': {x: 230, y: 250},
    'g1200-l-17-22': {x: 240, y: 250},
    'g1200-l-17-23': {x: 250, y: 250},
    'g1200-l-17-24': {x: 260, y: 250},
    'g1200-l-17-25': {x: 270, y: 250},
    'g1200-r-17-26': {x: 280, y: 250},
    'g1200-r-17-27': {x: 290, y: 250},
    'g1200-r-17-28': {x: 300, y: 250},
    'g1200-r-17-29': {x: 310, y: 250},
    'g1200-r-17-30': {x: 320, y: 250},
    'g1200-r-17-31': {x: 330, y: 250},
    'g1200-r-17-32': {x: 340, y: 250},
    'g1200-r-17-33': {x: 350, y: 250},
    'g1200-r-17-34': {x: 360, y: 250},
    'g1200-r-17-35': {x: 370, y: 250},
    'g1200-r-17-36': {x: 380, y: 250},
    'g1200-r-17-37': {x: 390, y: 250},
    'g1200-r-17-38': {x: 400, y: 250},
    'g1200-r-17-39': {x: 410, y: 250},
    'g1200-r-17-40': {x: 420, y: 250},
    'g1200-r-17-41': {x: 430, y: 250},
    'g1200-r-17-42': {x: 440, y: 250},
    'g1200-r-17-43': {x: 450, y: 250},
    'g1200-r-17-44': {x: 460, y: 250},
    'g1200-r-17-45': {x: 470, y: 250},
    'g1200-r-17-46': {x: 480, y: 250},
    'g1200-r-17-47': {x: 490, y: 250},
    'g1200-r-17-48': {x: 500, y: 250},
    'g1200-r-17-49': {x: 510, y: 250},
    'g1200-r-17-50': {x: 520, y: 250},

    'g1200-l-18-1': {x: 30, y: 265},
    'g1200-l-18-2': {x: 40, y: 265},
    'g1200-l-18-3': {x: 50, y: 265},
    'g1200-l-18-4': {x: 60, y: 265},
    'g1200-l-18-5': {x: 70, y: 265},
    'g1200-l-18-6': {x: 80, y: 265},
    'g1200-l-18-7': {x: 90, y: 265},
    'g1200-l-18-8': {x: 100, y: 265},
    'g1200-l-18-9': {x: 110, y: 265},
    'g1200-l-18-10': {x: 120, y: 265},
    'g1200-l-18-11': {x: 130, y: 265},
    'g1200-l-18-12': {x: 140, y: 265},
    'g1200-l-18-13': {x: 150, y: 265},
    'g1200-l-18-14': {x: 160, y: 265},
    'g1200-l-18-15': {x: 170, y: 265},
    'g1200-l-18-16': {x: 180, y: 265},
    'g1200-l-18-17': {x: 190, y: 265},
    'g1200-l-18-18': {x: 200, y: 265},
    'g1200-l-18-19': {x: 210, y: 265},
    'g1200-l-18-20': {x: 220, y: 265},
    'g1200-l-18-21': {x: 230, y: 265},
    'g1200-l-18-22': {x: 240, y: 265},
    'g1200-l-18-23': {x: 250, y: 265},
    'g1200-l-18-24': {x: 260, y: 265},
    'g1200-l-18-25': {x: 270, y: 265},
    'g1200-r-18-26': {x: 280, y: 265},
    'g1200-r-18-27': {x: 290, y: 265},
    'g1200-r-18-28': {x: 300, y: 265},
    'g1200-r-18-29': {x: 310, y: 265},
    'g1200-r-18-30': {x: 320, y: 265},
    'g1200-r-18-31': {x: 330, y: 265},
    'g1200-r-18-32': {x: 340, y: 265},
    'g1200-r-18-33': {x: 350, y: 265},
    'g1200-r-18-34': {x: 360, y: 265},
    'g1200-r-18-35': {x: 370, y: 265},
    'g1200-r-18-36': {x: 380, y: 265},
    'g1200-r-18-37': {x: 390, y: 265},
    'g1200-r-18-38': {x: 400, y: 265},
    'g1200-r-18-39': {x: 410, y: 265},
    'g1200-r-18-40': {x: 420, y: 265},
    'g1200-r-18-41': {x: 430, y: 265},
    'g1200-r-18-42': {x: 440, y: 265},
    'g1200-r-18-43': {x: 450, y: 265},
    'g1200-r-18-44': {x: 460, y: 265},
    'g1200-r-18-45': {x: 470, y: 265},
    'g1200-r-18-46': {x: 480, y: 265},
    'g1200-r-18-47': {x: 490, y: 265},
    'g1200-r-18-48': {x: 500, y: 265},
    'g1200-r-18-49': {x: 510, y: 265},
    'g1200-r-18-50': {x: 520, y: 265},

    'g1200-l-19-1': {x: 30, y: 280},
    'g1200-l-19-2': {x: 40, y: 280},
    'g1200-l-19-3': {x: 50, y: 280},
    'g1200-l-19-4': {x: 60, y: 280},
    'g1200-l-19-5': {x: 70, y: 280},
    'g1200-l-19-6': {x: 80, y: 280},
    'g1200-l-19-7': {x: 90, y: 280},
    'g1200-l-19-8': {x: 100, y: 280},
    'g1200-l-19-9': {x: 110, y: 280},
    'g1200-l-19-10': {x: 120, y: 280},
    'g1200-l-19-11': {x: 130, y: 280},
    'g1200-l-19-12': {x: 140, y: 280},
    'g1200-l-19-13': {x: 150, y: 280},
    'g1200-l-19-14': {x: 160, y: 280},
    'g1200-l-19-15': {x: 170, y: 280},
    'g1200-l-19-16': {x: 180, y: 280},
    'g1200-l-19-17': {x: 190, y: 280},
    'g1200-l-19-18': {x: 200, y: 280},
    'g1200-l-19-19': {x: 210, y: 280},
    'g1200-l-19-20': {x: 220, y: 280},
    'g1200-l-19-21': {x: 230, y: 280},
    'g1200-l-19-22': {x: 240, y: 280},
    'g1200-l-19-23': {x: 250, y: 280},
    'g1200-l-19-24': {x: 260, y: 280},
    'g1200-l-19-25': {x: 270, y: 280},
    'g1200-r-19-26': {x: 280, y: 280},
    'g1200-r-19-27': {x: 290, y: 280},
    'g1200-r-19-28': {x: 300, y: 280},
    'g1200-r-19-29': {x: 310, y: 280},
    'g1200-r-19-30': {x: 320, y: 280},
    'g1200-r-19-31': {x: 330, y: 280},
    'g1200-r-19-32': {x: 340, y: 280},
    'g1200-r-19-33': {x: 350, y: 280},
    'g1200-r-19-34': {x: 360, y: 280},
    'g1200-r-19-35': {x: 370, y: 280},
    'g1200-r-19-36': {x: 380, y: 280},
    'g1200-r-19-37': {x: 390, y: 280},
    'g1200-r-19-38': {x: 400, y: 280},
    'g1200-r-19-39': {x: 410, y: 280},
    'g1200-r-19-40': {x: 420, y: 280},
    'g1200-r-19-41': {x: 430, y: 280},
    'g1200-r-19-42': {x: 440, y: 280},
    'g1200-r-19-43': {x: 450, y: 280},
    'g1200-r-19-44': {x: 460, y: 280},
    'g1200-r-19-45': {x: 470, y: 280},
    'g1200-r-19-46': {x: 480, y: 280},
    'g1200-r-19-47': {x: 490, y: 280},
    'g1200-r-19-48': {x: 500, y: 280},
    'g1200-r-19-49': {x: 510, y: 280},
    'g1200-r-19-50': {x: 520, y: 280},

    'g1200-l-20-1': {x: 30, y: 295},
    'g1200-l-20-2': {x: 40, y: 295},
    'g1200-l-20-3': {x: 50, y: 295},
    'g1200-l-20-4': {x: 60, y: 295},
    'g1200-l-20-5': {x: 70, y: 295},
    'g1200-l-20-6': {x: 80, y: 295},
    'g1200-l-20-7': {x: 90, y: 295},
    'g1200-l-20-8': {x: 100, y: 295},
    'g1200-l-20-9': {x: 110, y: 295},
    'g1200-l-20-10': {x: 120, y: 295},
    'g1200-l-20-11': {x: 130, y: 295},
    'g1200-l-20-12': {x: 140, y: 295},
    'g1200-l-20-13': {x: 150, y: 295},
    'g1200-l-20-14': {x: 160, y: 295},
    'g1200-l-20-15': {x: 170, y: 295},
    'g1200-l-20-16': {x: 180, y: 295},
    'g1200-l-20-17': {x: 190, y: 295},
    'g1200-l-20-18': {x: 200, y: 295},
    'g1200-l-20-19': {x: 210, y: 295},
    'g1200-l-20-20': {x: 220, y: 295},
    'g1200-l-20-21': {x: 230, y: 295},
    'g1200-l-20-22': {x: 240, y: 295},
    'g1200-l-20-23': {x: 250, y: 295},
    'g1200-l-20-24': {x: 260, y: 295},
    'g1200-l-20-25': {x: 270, y: 295},
    'g1200-r-20-26': {x: 280, y: 295},
    'g1200-r-20-27': {x: 290, y: 295},
    'g1200-r-20-28': {x: 300, y: 295},
    'g1200-r-20-29': {x: 310, y: 295},
    'g1200-r-20-30': {x: 320, y: 295},
    'g1200-r-20-31': {x: 330, y: 295},
    'g1200-r-20-32': {x: 340, y: 295},
    'g1200-r-20-33': {x: 350, y: 295},
    'g1200-r-20-34': {x: 360, y: 295},
    'g1200-r-20-35': {x: 370, y: 295},
    'g1200-r-20-36': {x: 380, y: 295},
    'g1200-r-20-37': {x: 390, y: 295},
    'g1200-r-20-38': {x: 400, y: 295},
    'g1200-r-20-39': {x: 410, y: 295},
    'g1200-r-20-40': {x: 420, y: 295},
    'g1200-r-20-41': {x: 430, y: 295},
    'g1200-r-20-42': {x: 440, y: 295},
    'g1200-r-20-43': {x: 450, y: 295},
    'g1200-r-20-44': {x: 460, y: 295},
    'g1200-r-20-45': {x: 470, y: 295},
    'g1200-r-20-46': {x: 480, y: 295},
    'g1200-r-20-47': {x: 490, y: 295},
    'g1200-r-20-48': {x: 500, y: 295},
    'g1200-r-20-49': {x: 510, y: 295},
    'g1200-r-20-50': {x: 520, y: 295},

    'g1200-l-21-1': {x: 30, y: 310},
    'g1200-l-21-2': {x: 40, y: 310},
    'g1200-l-21-3': {x: 50, y: 310},
    'g1200-l-21-4': {x: 60, y: 310},
    'g1200-l-21-5': {x: 70, y: 310},
    'g1200-l-21-6': {x: 80, y: 310},
    'g1200-l-21-7': {x: 90, y: 310},
    'g1200-l-21-8': {x: 100, y: 310},
    'g1200-l-21-9': {x: 110, y: 310},
    'g1200-l-21-10': {x: 120, y: 310},
    'g1200-l-21-11': {x: 130, y: 310},
    'g1200-l-21-12': {x: 140, y: 310},
    'g1200-l-21-13': {x: 150, y: 310},
    'g1200-l-21-14': {x: 160, y: 310},
    'g1200-l-21-15': {x: 170, y: 310},
    'g1200-l-21-16': {x: 180, y: 310},
    'g1200-l-21-17': {x: 190, y: 310},
    'g1200-l-21-18': {x: 200, y: 310},
    'g1200-l-21-19': {x: 210, y: 310},
    'g1200-l-21-20': {x: 220, y: 310},
    'g1200-l-21-21': {x: 230, y: 310},
    'g1200-l-21-22': {x: 240, y: 310},
    'g1200-l-21-23': {x: 250, y: 310},
    'g1200-l-21-24': {x: 260, y: 310},
    'g1200-l-21-25': {x: 270, y: 310},
    'g1200-r-21-26': {x: 280, y: 310},
    'g1200-r-21-27': {x: 290, y: 310},
    'g1200-r-21-28': {x: 300, y: 310},
    'g1200-r-21-29': {x: 310, y: 310},
    'g1200-r-21-30': {x: 320, y: 310},
    'g1200-r-21-31': {x: 330, y: 310},
    'g1200-r-21-32': {x: 340, y: 310},
    'g1200-r-21-33': {x: 350, y: 310},
    'g1200-r-21-34': {x: 360, y: 310},
    'g1200-r-21-35': {x: 370, y: 310},
    'g1200-r-21-36': {x: 380, y: 310},
    'g1200-r-21-37': {x: 390, y: 310},
    'g1200-r-21-38': {x: 400, y: 310},
    'g1200-r-21-39': {x: 410, y: 310},
    'g1200-r-21-40': {x: 420, y: 310},
    'g1200-r-21-41': {x: 430, y: 310},
    'g1200-r-21-42': {x: 440, y: 310},
    'g1200-r-21-43': {x: 450, y: 310},
    'g1200-r-21-44': {x: 460, y: 310},
    'g1200-r-21-45': {x: 470, y: 310},
    'g1200-r-21-46': {x: 480, y: 310},
    'g1200-r-21-47': {x: 490, y: 310},
    'g1200-r-21-48': {x: 500, y: 310},
    'g1200-r-21-49': {x: 510, y: 310},
    'g1200-r-21-50': {x: 520, y: 310},

    'g1200-l-22-1': {x: 30, y: 325},
    'g1200-l-22-2': {x: 40, y: 325},
    'g1200-l-22-3': {x: 50, y: 325},
    'g1200-l-22-4': {x: 60, y: 325},
    'g1200-l-22-5': {x: 70, y: 325},
    'g1200-l-22-6': {x: 80, y: 325},
    'g1200-l-22-7': {x: 90, y: 325},
    'g1200-l-22-8': {x: 100, y: 325},
    'g1200-l-22-9': {x: 110, y: 325},
    'g1200-l-22-10': {x: 120, y: 325},
    'g1200-l-22-11': {x: 130, y: 325},
    'g1200-l-22-12': {x: 140, y: 325},
    'g1200-l-22-13': {x: 150, y: 325},
    'g1200-l-22-14': {x: 160, y: 325},
    'g1200-l-22-15': {x: 170, y: 325},
    'g1200-l-22-16': {x: 180, y: 325},
    'g1200-l-22-17': {x: 190, y: 325},
    'g1200-l-22-18': {x: 200, y: 325},
    'g1200-l-22-19': {x: 210, y: 325},
    'g1200-l-22-20': {x: 220, y: 325},
    'g1200-l-22-21': {x: 230, y: 325},
    'g1200-l-22-22': {x: 240, y: 325},
    'g1200-l-22-23': {x: 250, y: 325},
    'g1200-l-22-24': {x: 260, y: 325},
    'g1200-l-22-25': {x: 270, y: 325},
    'g1200-r-22-26': {x: 280, y: 325},
    'g1200-r-22-27': {x: 290, y: 325},
    'g1200-r-22-28': {x: 300, y: 325},
    'g1200-r-22-29': {x: 310, y: 325},
    'g1200-r-22-30': {x: 320, y: 325},
    'g1200-r-22-31': {x: 330, y: 325},
    'g1200-r-22-32': {x: 340, y: 325},
    'g1200-r-22-33': {x: 350, y: 325},
    'g1200-r-22-34': {x: 360, y: 325},
    'g1200-r-22-35': {x: 370, y: 325},
    'g1200-r-22-36': {x: 380, y: 325},
    'g1200-r-22-37': {x: 390, y: 325},
    'g1200-r-22-38': {x: 400, y: 325},
    'g1200-r-22-39': {x: 410, y: 325},
    'g1200-r-22-40': {x: 420, y: 325},
    'g1200-r-22-41': {x: 430, y: 325},
    'g1200-r-22-42': {x: 440, y: 325},
    'g1200-r-22-43': {x: 450, y: 325},
    'g1200-r-22-44': {x: 460, y: 325},
    'g1200-r-22-45': {x: 470, y: 325},
    'g1200-r-22-46': {x: 480, y: 325},
    'g1200-r-22-47': {x: 490, y: 325},
    'g1200-r-22-48': {x: 500, y: 325},
    'g1200-r-22-49': {x: 510, y: 325},
    'g1200-r-22-50': {x: 520, y: 325},

    'g1200-l-23-1': {x: 30, y: 340},
    'g1200-l-23-2': {x: 40, y: 340},
    'g1200-l-23-3': {x: 50, y: 340},
    'g1200-l-23-4': {x: 60, y: 340},
    'g1200-l-23-5': {x: 70, y: 340},
    'g1200-l-23-6': {x: 80, y: 340},
    'g1200-l-23-7': {x: 90, y: 340},
    'g1200-l-23-8': {x: 100, y: 340},
    'g1200-l-23-9': {x: 110, y: 340},
    'g1200-l-23-10': {x: 120, y: 340},
    'g1200-l-23-11': {x: 130, y: 340},
    'g1200-l-23-12': {x: 140, y: 340},
    'g1200-l-23-13': {x: 150, y: 340},
    'g1200-l-23-14': {x: 160, y: 340},
    'g1200-l-23-15': {x: 170, y: 340},
    'g1200-l-23-16': {x: 180, y: 340},
    'g1200-l-23-17': {x: 190, y: 340},
    'g1200-l-23-18': {x: 200, y: 340},
    'g1200-l-23-19': {x: 210, y: 340},
    'g1200-l-23-20': {x: 220, y: 340},
    'g1200-l-23-21': {x: 230, y: 340},
    'g1200-l-23-22': {x: 240, y: 340},
    'g1200-l-23-23': {x: 250, y: 340},
    'g1200-l-23-24': {x: 260, y: 340},
    'g1200-l-23-25': {x: 270, y: 340},
    'g1200-r-23-26': {x: 280, y: 340},
    'g1200-r-23-27': {x: 290, y: 340},
    'g1200-r-23-28': {x: 300, y: 340},
    'g1200-r-23-29': {x: 310, y: 340},
    'g1200-r-23-30': {x: 320, y: 340},
    'g1200-r-23-31': {x: 330, y: 340},
    'g1200-r-23-32': {x: 340, y: 340},
    'g1200-r-23-33': {x: 350, y: 340},
    'g1200-r-23-34': {x: 360, y: 340},
    'g1200-r-23-35': {x: 370, y: 340},
    'g1200-r-23-36': {x: 380, y: 340},
    'g1200-r-23-37': {x: 390, y: 340},
    'g1200-r-23-38': {x: 400, y: 340},
    'g1200-r-23-39': {x: 410, y: 340},
    'g1200-r-23-40': {x: 420, y: 340},
    'g1200-r-23-41': {x: 430, y: 340},
    'g1200-r-23-42': {x: 440, y: 340},
    'g1200-r-23-43': {x: 450, y: 340},
    'g1200-r-23-44': {x: 460, y: 340},
    'g1200-r-23-45': {x: 470, y: 340},
    'g1200-r-23-46': {x: 480, y: 340},
    'g1200-r-23-47': {x: 490, y: 340},
    'g1200-r-23-48': {x: 500, y: 340},
    'g1200-r-23-49': {x: 510, y: 340},
    'g1200-r-23-50': {x: 520, y: 340},

    'g1200-l-24-1': {x: 30, y: 355},
    'g1200-l-24-2': {x: 40, y: 355},
    'g1200-l-24-3': {x: 50, y: 355},
    'g1200-l-24-4': {x: 60, y: 355},
    'g1200-l-24-5': {x: 70, y: 355},
    'g1200-l-24-6': {x: 80, y: 355},
    'g1200-l-24-7': {x: 90, y: 355},
    'g1200-l-24-8': {x: 100, y: 355},
    'g1200-l-24-9': {x: 110, y: 355},
    'g1200-l-24-10': {x: 120, y: 355},
    'g1200-l-24-11': {x: 130, y: 355},
    'g1200-l-24-12': {x: 140, y: 355},
    'g1200-l-24-13': {x: 150, y: 355},
    'g1200-l-24-14': {x: 160, y: 355},
    'g1200-l-24-15': {x: 170, y: 355},
    'g1200-l-24-16': {x: 180, y: 355},
    'g1200-l-24-17': {x: 190, y: 355},
    'g1200-l-24-18': {x: 200, y: 355},
    'g1200-l-24-19': {x: 210, y: 355},
    'g1200-l-24-20': {x: 220, y: 355},
    'g1200-l-24-21': {x: 230, y: 355},
    'g1200-l-24-22': {x: 240, y: 355},
    'g1200-l-24-23': {x: 250, y: 355},
    'g1200-l-24-24': {x: 260, y: 355},
    'g1200-l-24-25': {x: 270, y: 355},
    'g1200-r-24-26': {x: 280, y: 355},
    'g1200-r-24-27': {x: 290, y: 355},
    'g1200-r-24-28': {x: 300, y: 355},
    'g1200-r-24-29': {x: 310, y: 355},
    'g1200-r-24-30': {x: 320, y: 355},
    'g1200-r-24-31': {x: 330, y: 355},
    'g1200-r-24-32': {x: 340, y: 355},
    'g1200-r-24-33': {x: 350, y: 355},
    'g1200-r-24-34': {x: 360, y: 355},
    'g1200-r-24-35': {x: 370, y: 355},
    'g1200-r-24-36': {x: 380, y: 355},
    'g1200-r-24-37': {x: 390, y: 355},
    'g1200-r-24-38': {x: 400, y: 355},
    'g1200-r-24-39': {x: 410, y: 355},
    'g1200-r-24-40': {x: 420, y: 355},
    'g1200-r-24-41': {x: 430, y: 355},
    'g1200-r-24-42': {x: 440, y: 355},
    'g1200-r-24-43': {x: 450, y: 355},
    'g1200-r-24-44': {x: 460, y: 355},
    'g1200-r-24-45': {x: 470, y: 355},
    'g1200-r-24-46': {x: 480, y: 355},
    'g1200-r-24-47': {x: 490, y: 355},
    'g1200-r-24-48': {x: 500, y: 355},
    'g1200-r-24-49': {x: 510, y: 355},
    'g1200-r-24-50': {x: 520, y: 355},
  }
}



// WEBPACK FOOTER //
// ./src/store/svg.js